export default {
  "custom": {
    linkedReference: 'อ้างอิงที่เชื่อมโยง',
    boot: 'เปิดเครื่อง',
    shutDown: 'ปิดเครื่อง',
    notLinked: 'ไม่เชื่อมโยง',
    maxLinkedTip: 'อนุญาตให้เชื่อมโยง {type} สูงสุด 2 รายการ กู้คืนเป็น ไม่เชื่อมโยง โดยอัตโนมัติ',

    bar_Power: 'พลังงาน',
    bar_Video: 'สลับวิดีโอ',
    bar_Vol: 'ระดับเสียง',
    bar_Audio: 'สลับเสียง',
    bar_Serial: 'แบบอนุกรม',
    bar_Air: 'เครื่องปรับอากาศ',
    bar_Projection: 'จอโปรเจกเตอร์',
    bar_Remote: 'รีโมตคอนโทรล',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'คุณต้องเลือกภาพทั้งสามพร้อมกัน',
    notSelected: 'ไม่ได้เลือก',
    choose: 'เลือก',
    disable: 'ปิดการใช้งาน',
    "longPressAndDrag": "กดค้างแล้วลากเพื่อปรับลำดับรายการ",
    "isrestoreDefault": "คุณต้องการกู้คืนเป็นค่าเริ่มต้นหรือไม่?",
    "saveAndSync": "บันทึกและซิงค์",
    "restoreDefault": "คืนค่าเริ่มต้น",
    "limitPNG": "สามารถอัปโหลดได้เฉพาะภาพ PNG เท่านั้น!",
    "limit1M": "ขนาดภาพต้องไม่เกิน 1MB!",
    "selectTheImage": "เลือกภาพ",
    "textsuggestions": "แนะนำ: ไอคอน PNG สีขาว 48*48 px ขนาดไม่เกิน 1MB",
    "iconLibrary": "คลังไอคอน",
    "panelNavigationBarCustomization": "แถบนำทางของแผง",
    "logoCustomization": "โลโก้แผง"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'การเชื่อมโยงล้มเหลว: ผู้เช่าของ Microsoft นี้ (ID: ',
    AuthVerify4004Two: ') ถูกใช้งานโดยองค์กร [',
    AuthVerify4004Three: '] เพื่อเชื่อมโยงใหม่ โปรดยกเลิกการเชื่อมโยงจากองค์กรเดิมก่อนหรือใช้ผู้เช่าของ Microsoft รายอื่น',
    theMicrosoftTenantIsOccupied: 'ผู้เช่าของ Microsoft ถูกใช้งานแล้ว',
    Viewtutorial: 'ดูบทเรียนการผูกมัด',
    checktenantID: 'โปรดตรวจสอบว่า Tenant ID, Application ID และ Application Key ของคุณถูกต้องหรือไม่',
    ErrorCode: 'รหัสข้อผิดพลาด:',
    AuthorizationFailed: 'การอนุญาตล้มเหลว',
    Accesshasbeengranted: 'ได้รับสิทธิ์เข้าถึง Microsoft Graph API แล้ว',
    successfullyauthorizedDescribe: 'ได้รับสิทธิ์ที่จำเป็นเรียบร้อยแล้ว ข้อมูลห้องประชุมจะถูกซิงค์อัตโนมัติ กรุณาปิดหน้านี้',
    Close: 'ปิด',
    resourceID: 'รหัสทรัพยากร',
    dialogTips: 'คำแนะนำ',
    theAuthorizationIsDeleted: 'ยกเลิกการอนุญาตแล้ว',
    theBindingIsSuccessful: 'ผูกมัดสำเร็จ',
    theUnbindingIsSuccessful: 'ยกเลิกการผูกมัดสำเร็จ',
    unbindingFailed: 'ยกเลิกการผูกมัดล้มเหลว',
    theUnbindingHasBeenUnbound: 'ยกเลิกการผูกมัดแล้ว',
    continueUnbinding: 'การซิงค์ Outlook จะหยุดและกิจกรรมทั้งหมดที่จะเกิดขึ้นจะถูกลบออก ยืนยันยกเลิกการผูกมัด?',
    areYouSureAboutUnbinding: 'กิจกรรม Outlook ทั้งหมดที่จะเกิดขึ้นจะถูกลบออกและการซิงค์จะหยุด การกระทำนี้ไม่สามารถยกเลิกได้ ยืนยันยกเลิกการผูกมัด?',
    UnbindNotSynchronized: 'หลังการผูกมัด กิจกรรม Outlook ใหม่สำหรับห้องนี้จะถูกซิงค์อัตโนมัติ (กิจกรรมเก่าจะไม่ถูกซิงค์)',
    unbinding: 'ยกเลิกการผูกมัด',
    bindUnableToSelect: 'ถูกผูกมัดแล้ว ไม่สามารถเลือกได้',
    permissAThird: 'โปรดอนุญาตเพื่อผูกมัดทรัพยากรของบุคคลที่สาม',
    resourceMailbox: 'อีเมลทรัพยากร:',
    PleasecheckID: 'การอนุญาตล้มเหลว! โปรดตรวจสอบว่า Tenant ID, Application ID และ Client Secret ของคุณถูกต้องหรือไม่',
    Waitingforauthorization: 'กำลังรอการอนุญาต...',
    Pleasecompletetheauthorization: 'เปิดหน้าเข้าสู่ระบบ Microsoft 365 แล้ว กรุณาเข้าสู่ระบบด้วยบัญชีผู้ดูแลระบบเพื่อดำเนินการอนุญาตให้เสร็จสิ้น',
    pleaseEnterTheTenantID: 'กรุณาใส่ Tenant ID',
    pleaseEnterTheClientID: 'กรุณาใส่ Application ID',
    pleaseEnterTheClientSecret: 'กรุณาใส่ Client Secret',
    Authorizationcompleted: 'การอนุญาตเสร็จสิ้น',
    Authorizelogin: 'อนุญาตการเข้าสู่ระบบ Microsoft 365',
    ApplicationID: 'Tenant ID',
    ClientID: 'Application ID',
    ClientSecret: 'Client Secret',
    registTipOne: 'กรุณาปฏิบัติตาม',
    registTipTwo: 'คู่มือการผูกมัด',
    registTipThree: 'ดำเนินการลงทะเบียนแอป Azure และตั้งค่าสิทธิ์ให้เสร็จสิ้นก่อนกรอกข้อมูลด้านล่าง',
    MicrosoftDescribe: 'การผูกมัด Microsoft 365 ทำให้การประชุมที่จองใน Outlook/Teams สามารถซิงค์ไปยัง Q-NEX Console และ Room Scheduler อัตโนมัติ',
    Addcalendarservice: 'ตั้งค่าการซิงค์ปฏิทิน',
    Lasttimesynchronization: 'เวลาซิงค์ล่าสุด',
    Allocated: 'จัดสรรแล้ว',
    Total: 'ทั้งหมด',
    Conferenceroomresources: 'ทรัพยากรห้องประชุม',
    Bindingtime: 'เวลาผูกมัด',
    Bindtheplatform: 'แพลตฟอร์มที่ผูกมัด',
    Synchronousstate: 'สถานะการซิงค์',
    Organizationname: 'ชื่อองค์กร',
    Bindthirdpartycalendar: 'ผูกมัดปฏิทินบุคคลที่สาม',
    TenantIDTip: 'ตัวระบุเฉพาะใน Azure AD',
    ApplicationIDTip: 'รหัสแอปพลิเคชันที่ลงทะเบียนใน Azure',
    ApplicationSecretTip: 'Client secret ที่สร้างใน Azure สำหรับการยืนยันตัวตน'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'ข้อความแสดงสถานะว่าง',
    IdleDisplayText: 'ข้อความแสดงสถานะว่าง:',
    IdleDisplayTextContent: 'ข้อความที่แสดงเมื่อห้องว่าง (ค่าเริ่มต้น: “ว่าง”)',

    duplicateMeetingRoomName: 'ชื่อห้องประชุมซ้ำ',
    duplicateMeetingRoomNameContent: 'มีห้องประชุมชื่อ "{duplicate_content}" อยู่แล้ว กรุณาใช้ชื่ออื่น',
    NumberOfRoomPanels: 'จำนวนแผงห้องประชุม',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "เทอร์มินัลปัจจุบันถูกผูกกับองค์กรอื่นแล้ว.",
    "theTerminalNameOrIDIsDuplicated": "ชื่อหรือรหัสของแผงเหมือนกัน",
    theRoomNameOrIDIsDuplicated: 'ชื่อห้องประชุมหรือสถานที่ซ้ำกัน',
    "AddMeetingRoom": "เพิ่มห้องประชุม",
    "EditMeetingRoom": "แก้ไขห้องประชุม",
    "MeetingRoomName": "ชื่อห้องประชุม:",
    "Location": "ที่ตั้ง:",
    "ReservationApproval": "การอนุมัติการจอง:",
    "ApprovalListYes": "ใช่",
    "ApprovalListNo": "ไม่",
    "Capacity": "ความจุ:",
    "RoomStatus": "สถานะห้อง:",
    "BindRoomDisplay": "เชื่อมต่อแผงห้อง:",
    "meeting_btnAdd": "เพิ่ม",
    "meeting_btnEdit": "แก้ไข",
    "meeting_btnBind": "เชื่อมต่ออุปกรณ์",
    "meeting_btnDel": "ลบ",
    "meeting_tableRoomName": "ชื่อห้องประชุม",
    "meeting_tableRoomPlace": "ที่ตั้ง",
    "meeting_tableAppointmentApproval": "การอนุมัติการจอง",
    "meeting_tableCapacityForPeople": "ความจุ",
    "meeting_tableMeetingRoomStatus": "สถานะห้อง",
    "meeting_tableAvaliable": "พร้อมใช้งาน",
    "meeting_tableOutofService": "ไม่ให้บริการ",
    "meeting_tableDoorBind": "เชื่อมต่อประตู",
    "meeting_tableBindNPS": "เชื่อมต่อ NPS",
    "meeting_tableActions": "การกระทำ",
    "door_theNameOfTheTerminal": "ชื่อแผง:",
    "door_deviceID": "รหัสแผง:",
    "door_Wallpaper": "พื้นหลัง:",
    "door_Wallpaper_text": "ขนาดภาพที่แนะนำ: 1280x800, ในรูปแบบ PNG",
    "door_bindAMeetingRoom": "เชื่อมต่อห้องประชุม:",
    "door_table_name": "ชื่อแผง",
    "door_table_deviceID": "รหัสแผง",
    "door_table_status": "สถานะ",
    "door_table_ipAddress": "ที่อยู่ IP",
    "door_table_bindAMeetingRoom": "เชื่อมต่อห้องประชุม",
    "door_btnAdd": "เพิ่ม",
    "door_btnBatchAdd": "เพิ่มเป็นชุด",
    "door_btnEdit": "แก้ไข",
    "door_btnBatchEdit": "แก้ไขเป็นชุด"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "เพิ่มการตั้งค่า",
    "configurationEditTitle": "แก้ไขการตั้งค่า",
    "dialogConfigName": "ชื่อการตั้งค่า",
    "selectNMPAndNDP": "อุปกรณ์เป้าหมาย",
    "powerControl": "การควบคุมพลังงาน",
    "executeCommand": "ทำ",
    "tableConfigName": "ชื่อการตั้งค่า",
    "selectConfig": "โปรดเลือกการตั้งค่า"
  },
  "NPS": {
    "Relay": "รีเลย์",
    "RelaySettings": "การตั้งค่ารีเลย์",
    "DevicePower": "การควบคุมพลังงานของอุปกรณ์",
    "DeviceElevation": "การควบคุมการยกระดับ",
    "LinageWithNPSPower": "เชื่อมโยงกับพลังงาน NPS",
    "PresentationSwitch": "สวิตช์การนำเสนอ",
    "Duplicate": "ทำซ้ำ",
    "LinkagewithNPSPowe": "เชื่อมโยงกับพลังงาน NPS"
  },
  "PTZ": {
    "powerSupplyON": "เปิด",
    "powerSupplyOFF": "ปิด",
    "LEFT": "ซ้าย",
    "RIGHT": "ขวา",
    "UP": "ขึ้น",
    "DOWN": "ลง",
    "HOME": "หน้าแรก",
    "ENLARGE": "ขยาย",
    "REDUCTION": "ย่อ",
    "StopMovement": "หยุดการเคลื่อนไหว",
    "STOP": "หยุดการซูม",
    "FOCUS": "โฟกัส",
    "SET_PRESETS0": "ตั้งค่า_พรีเซ็ต0",
    "SET_PRESETS1": "ตั้งค่า_พรีเซ็ต1",
    "SET_PRESETS2": "ตั้งค่า_พรีเซ็ต2",
    "SET_PRESETS3": "ตั้งค่า_พรีเซ็ต3",
    "SET_PRESETS4": "ตั้งค่า_พรีเซ็ต4",
    "SET_PRESETS5": "ตั้งค่า_พรีเซ็ต5",
    "SET_PRESETS6": "ตั้งค่า_พรีเซ็ต6",
    "SET_PRESETS7": "ตั้งค่า_พรีเซ็ต7",
    "SET_PRESETS8": "ตั้งค่า_พรีเซ็ต8",
    "SET_PRESETS9": "ตั้งค่า_พรีเซ็ต9",
    "USE_PRESETS0": "ใช้_พรีเซ็ต0",
    "USE_PRESETS1": "ใช้_พรีเซ็ต1",
    "USE_PRESETS2": "ใช้_พรีเซ็ต2",
    "USE_PRESETS3": "ใช้_พรีเซ็ต3",
    "USE_PRESETS4": "ใช้_พรีเซ็ต4",
    "USE_PRESETS5": "ใช้_พรีเซ็ต5",
    "USE_PRESETS6": "ใช้_พรีเซ็ต6",
    "USE_PRESETS7": "ใช้_พรีเซ็ต7",
    "USE_PRESETS8": "ใช้_พรีเซ็ต8",
    "USE_PRESETS9": "ใช้_พรีเซ็ต9"
  },
  "schedule": {
    "startLinkPowerStart": "เปิด (รีเลย์ CBXs)  ",
    "startLinkPowerStop": "ปิด (รีเลย์ CBXs)  ",
    "dehumidification": "แห้ง  ",
    "airSupply": "พัดลม  ",
    "masterControl": "หลัก:  ",
    "powerSupply": "พลังงาน  ",
    "lockScreen": "ล็อค  ",
    "RecordingControl": "ควบคุมการบันทึก  ",
    "RecordingControlSystem": "ระบบจับภาพการบรรยาย  ",
    "LiquidCrystal": "จอแสดงผลแบบอินเตอร์แอคทีฟ  ",
    "projector": "โปรเจคเตอร์  ",
    "othertype": "อื่นๆ  ",
    "childLock": "ล็อคเด็ก  ",
    "energySaving": "การประหยัดพลังงาน  ",
    "signalSourceSwitching": "แหล่งอินพุต  ",
    "other": "คุณสมบัติอื่นๆ:  ",
    "otherFunction": "ฟังก์ชัน  ",
    "send": "ส่ง  ",
    "ON": "เปิด  ",
    "OFF": "ปิด  ",
    "btnAddSchedule": "คืนค่า  ",
    "EditSchedulelist": "แก้ไขตัวจัดการตาราง  ",
    "AddSchedulelist": "เพิ่มตัวจัดการตาราง  ",
    "RestoreSchedulelist": "คืนค่า  ",
    "btn": "ยกเลิก  ",
    "btnNewList": "ตัวจัดการตารางใหม่  ",
    "ListName": "ชื่อ  ",
    "Cannotquit": "บังคับ  ",
    "NOCannotquit": "ไม่  ",
    "ListValidityPeriod": "ระยะเวลาการใช้งาน  ",
    "ListDescription": "คำอธิบาย  ",
    "currentSchedule": "รายการตัวจัดการตาราง  ",
    "historySchedule": "รายการประวัติ  ",
    "selectTime": "เวลา  ",
    "taskType": "ประเภทงาน  ",
    "selectBroadcasting": "การออกอากาศ  ",
    "selectDeviveControl": "ควบคุมอุปกรณ์  ",
    "newSchedule": "งานใหม่  ",
    "newChecklist": "รายการตรวจสอบใหม่  ",
    "titleStatus": "สถานะ  ",
    "titleType": "ประเภท  ",
    "titleStartTime": "เวลาเริ่มต้น  ",
    "titleEndTime": "เวลาสิ้นสุด  ",
    "titleRepeat": "ทำซ้ำ  ",
    "titleName": "ชื่อ  ",
    "titleAction": "การกระทำ  ",
    "tableEnabled": "เปิดใช้งาน  ",
    "tablePaused": "พัก  ",
    "tableEdit": "แก้ไข  ",
    "tableDelete": "ลบ",
    "tableVolumeEdit": "ปริมาณการกระจาย  ",
    "tableBroadcastTitle": "ชื่อเรื่อง  ",
    "tableBroadcastContent": "เนื้อหา  ",
    "tableBroadcastList": "รายการ  ",
    "tableBroadcast": "บังคับ  ",
    "btnRemoveCompletely": "ลบทั้งหมด  ",
    "btnEnabled": "เปิดใช้งาน  ",
    "btnPaused": "หยุดชั่วคราว  ",
    "btnDelete": "ลบ  ",
    "repeat0": "จันทร์  ",
    "repeat1": "อังคาร  ",
    "repeat2": "พุธ  ",
    "repeat3": "พฤหัสบดี  ",
    "repeat4": "ศุกร์  ",
    "repeat5": "เสาร์  ",
    "repeat6": "อาทิตย์  ",
    "dialogTitleAdd": "งานควบคุมอุปกรณ์ใหม่  ",
    "dialogTitleEdit": "แก้ไขงานควบคุมอุปกรณ์  ",
    "newBroadcastingSchedule": "งานกระจายใหม่  ",
    "editBroadcastingSchedule": "แก้ไขงานกระจาย  ",
    "chooseDevice": "เลือกอุปกรณ์  ",
    "timeSetting": "ตั้งเวลา  ",
    "controlBroadcasting": "ตัวเลือกการกระจาย  ",
    "controlOption": "ตัวเลือกการควบคุม  ",
    "scheduleName": "ชื่อภารกิจ:  ",
    "destination": "ปลายทาง  ",
    "timeTilte": "เวลา  ",
    "repeatTitle": "ทำซ้ำ  ",
    "dialogRepeat0": "จันทร์  ",
    "dialogRepeat1": "อังคาร  ",
    "dialogRepeat2": "พุธ  ",
    "dialogRepeat3": "พฤหัสบดี  ",
    "dialogRepeat4": "ศุกร์  ",
    "dialogRepeat5": "เสาร์  ",
    "dialogRepeat6": "อาทิตย์  ",
    "dialogOnceType": "ครั้งเดียว  ",
    "dialogRepeatType": "ทำซ้ำ  ",
    "mainPower": "พลังงานหลัก  ",
    "powerControl": "ควบคุมพลังงาน  ",
    "tableDisplayInputSwitch": "สวิตช์อินพุตการแสดงผล  ",
    "tableAirConditioning": "เครื่องปรับอากาศ  ",
    "tableProjectionScreen": "จอภาพ  ",
    "tableElectronicLock": "ล็อคไฟฟ้า  ",
    "interactiveFlatPanel": "แผงอินเตอร์แอคทีฟ  ",
    "displayInputSwitch": "สวิตช์อินพุตการแสดงผล  ",
    "speakerVolume": "ระดับเสียงลำโพง  ",
    "MICVolume": "ระดับเสียงไมโครโฟน  ",
    "ProjectionScreen": "จอภาพ  ",
    "ElectronicLock": "ล็อคไฟฟ้า  ",
    "AirConditioning": "เครื่องปรับอากาศ",
    "AirConditioningPower": "พลังงาน  ",
    "AirConditioningModel": "รุ่น  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "ความเร็วพัดลม  ",
    "OPEN": "เปิด  ",
    "CLOSE": "ปิด  ",
    "UP": "ขึ้น  ",
    "DOWN": "ลง  ",
    "PowerOFF": "ปิด  ",
    "PowerON": "เปิด  ",
    "ModelAuto": "อัตโนมัติ  ",
    "ModelCool": "เย็น  ",
    "ModelHeat": "ร้อน  ",
    "ModelAir": "ด้านอากาศ  ",
    "TEMPLow": "ต่ำ  ",
    "TEMPMiddle": "กลาง  ",
    "TEMPHigh": "สูง  ",
    "btnSave": "บันทึก  ",
    "btnNext": "ถัดไป  ",
    "StartTime": "เวลาเริ่มต้น  ",
    "StopTime": "เวลาหยุด  ",
    "Mandatory": "จำเป็น  ",
    "Video": "วิดีโอ & เสียง  ",
    "Notification": "การแจ้งเตือน  ",
    "btnFile": "เลือกไฟล์สื่อ  ",
    "LastingTime": "ระยะเวลา  ",
    "textTitle": "หัวข้อ  ",
    "textContent": "เนื้อหา  ",
    "textTitleLetters": "น้อยกว่า 60 ตัวอักษร  ",
    "textContentLetters": "น้อยกว่า 320 ตัวอักษร  ",
    "CannotquitYES": "ใช่  ",
    "CannotquitNo": "ไม่  ",
    "YES": "ใช่  ",
    "No": "ไม่  ",
    "delTitleContent": "คุณแน่ใจหรือว่าต้องการลบตัวจัดการนี้?  ",
    "delTitleListContent": "ตัวจัดการที่ถูกลบจะถูกย้ายไปยังรายการประวัติและสามารถกู้คืนได้  ",
    "deleListTitle": "ลบตัวจัดการ?  ",
    "delTitleListContent1": "การลบตัวจัดการจะทำให้งานที่เกี่ยวข้องกับมันถูกลบ กรุณายืนยัน  ",
    "deleListTitle1": "คุณแน่ใจหรือว่าต้องการลบตัวจัดการนี้?  ",
    "delTitle": "ลบ?  ",
    "btnConfirm": "ยืนยัน  ",
    "coxAll": "ทั้งหมด  ",
    "coxBroadcasting": "การออกอากาศ  ",
    "coxDeviveControl": "การควบคุมอุปกรณ์  ",
    "rdMandatory": "ใช่  ",
    "noRdMandatory": "ไม่  ",
    "startDate": "วันที่เริ่มต้น  ",
    "endedDate": "วันที่สิ้นสุด  ",
    "or": "-  ",
    "broadcastingType": "ประเภท",
    "ChooseTime": "เลือกเวลา  ",
    "ChooseDate": "เลือกวันที่  ",
    "newScheduleList": "โปรแกรมใหม่  ",
    "editScheduleList": "แก้ไขโปรแกรม  ",
    "listName": "ชื่อ  ",
    "listValidityPeriod": "ระยะเวลาที่ใช้  ",
    "listDescription": "คำอธิบาย  ",
    "cancel": "ยกเลิก  ",
    "confirm": "ยืนยัน  ",
    "save": "บันทึก  ",
    "addSuccess": "เพิ่มสำเร็จ!  ",
    "addError": "เพิ่มล้มเหลว!  ",
    "editSuccess": "แก้ไขสำเร็จ!  ",
    "editError": "แก้ไขล้มเหลว!  ",
    "delSuccess": "ลบสำเร็จ!  ",
    "delError": "ลบล้มเหลว!  ",
    "restoreSuccess": "รายการโปรแกรมคืนค่าด้วยความสำเร็จ  ",
    "restoreError": "ไม่สามารถกู้คืนรายการโปรแกรมได้  ",
    "restoreTitleContent": "เวลานี้ขัดแย้งกับเวลาของโปรแกรมในรายการ กรุณาเลือกใหม่  ",
    "Enabled": "เปิดใช้งาน  ",
    "Paused": "หยุดชั่วคราว  ",
    "Title": "ชื่อเรื่อง:  ",
    "Content": "เนื้อหา:  ",
    "errorScheduleNameRequired": "ต้องกรอกชื่อภารกิจ  ",
    "errorDeviceRequired": "กรุณาเลือกอุปกรณ์เป้าหมาย  ",
    "deleTitle": "คุณแน่ใจหรือไม่ว่าต้องการลบภารกิจนี้?  ",
    "loopList": "รายการทำซ้ำ  ",
    "errorPleaseDateRange": "กรุณาเลือกช่วงวันที่  ",
    "addError_2009": "ชื่อโปรแกรมซ้ำ  ",
    "conflicts": "เวลาภารกิจขัดแย้งกับเวลาต่อไปนี้:  ",
    "Pleaseagain": "กรุณากรอกใหม่  ",
    "errorScheduleName": "ชื่อภารกิจ  ",
    "errorListName": "ชื่อโปรแกรม  ",
    "today": "วันนี้  ",
    "yesterday": "เมื่อวานนี้  ",
    "thisWeek": "สัปดาห์นี้  ",
    "lastWeek": "สัปดาห์ที่แล้ว  ",
    "lastMonth": "เดือนที่แล้ว  ",
    "thisMonth": "เดือนนี้  ",
    "times": "ครั้ง  ",
    "TimeConflicts": "ความขัดแย้งของเวลา  ",
    "editError_2006": "ไม่พบอุปกรณ์  ",
    "editError_2010": "ชื่อภารกิจซ้ำ  ",
    "ListTimeExpired": "เวลาของโปรแกรมหมดอายุ กรุณาเลือกใหม่  ",
    "TimeExpired": "เวลาหมดอายุ  ",
    "ControlOption": "ตัวเลือกควบคุมขาดหายไป  ",
    "Pleaseleastone": "กรุณาเลือกตัวเลือกควบคุมอย่างน้อยหนึ่งตัวเลือก  ",
    "Enter": "เข้าสู่ระบบ  ",
    "TitleFilled": "ต้องกรอกชื่อเรื่อง  ",
    "ContentFilled": "ต้องกรอกเนื้อหา  ",
    "PleaseMediaFile": "โปรดเลือกไฟล์สื่อ  ",
    "PleaseSchedule": "โปรดเลือกงาน  ",
    "delTitleScheduleContent": "ไม่สามารถกู้คืนงานที่ถูกลบ  ",
    "deleTitleSchedule": "คุณแน่ใจหรือไม่ว่าต้องการลบงานนี้?  ",
    "deleteScheduleTitle": "โปรดเลือกงานที่จะลบ  ",
    "PleaseFillColumn": "โปรดกรอกชื่อโปรแกรม  ",
    "PleaseDate": "โปรดเลือกวันที่  ",
    "Previous": "ก่อนหน้า  ",
    "RemoteControl": "รีโมทคอนโทรล  ",
    "taskhasexpired": "งานนี้หมดอายุแล้ว โปรดติดต่อผู้สร้างเพื่ออัปเดตเวลา  ",
    "execute": "ดำเนินการ  ",
    "broadcastingList": "รายการออกอากาศ  ",
    "volumeSuccess": "ตั้งค่าระดับเสียงสำเร็จ  ",
    "volumeFailed": "ตั้งค่าระดับเสียงล้มเหลว  "
  },
  "Automation": {
    "nameDuplicate": "ชื่องานซ้ำโดยอัตโนมัติ  ",
    "Automation": "การทำงานอัตโนมัติ  ",
    "if": "หาก:  ",
    "ifContent": "ส่วน 'หาก' ให้คุณตั้งเงื่อนไขตามข้อมูลจากเซ็นเซอร์ เลือกเซ็นเซอร์และกำหนดเงื่อนไข เช่น 'อุณหภูมิ > 26°C'  ",
    "then": "จากนั้น:  ",
    "thenContent": "ส่วน 'จากนั้น' ให้คุณเลือกอุปกรณ์และกำหนดการกระทำสำหรับอุปกรณ์นั้น เลือกอุปกรณ์เช่น NMP1, NMP2 และกำหนดการกระทำ เช่น 'เปิด + เย็น' สำหรับเครื่องปรับอากาศ  ",
    "btnDelete": "ลบ  ",
    "Add": "เพิ่ม  ",
    "taskName": "ชื่อของงาน  ",
    "dialogTaskName": "ชื่อของงาน:  ",
    "Statue": "สถานะ  ",
    "DevicesApplied": "อุปกรณ์ที่ใช้  ",
    "Operation": "การดำเนินการ  ",
    "AirConditioningPower": "พลังงาน  ",
    "AirConditioningModel": "โมเดล  ",
    "AirConditioningFanSpeed": "ความเร็วพัดลม  ",
    "bold": "การสวิง  ",
    "selectTask": "โปรดเลือกงาน  ",
    "autoTaskAdd": "เพิ่มงานอัตโนมัติ  ",
    "autoTaskEdit": "แก้ไขงานอัตโนมัติ  ",
    "Destination": "ปลายทาง  ",
    "selectConditions": "โปรดระบุการกระทำที่คุณต้องการดำเนินการ  ",
    "selectDestination": "โปรดเลือกอุปกรณ์ NMP เป้าหมาย จากนั้นระบุการกระทำที่คุณต้องการดำเนินการ  ",
    "AirConditioningTEMP": "อุณหภูมิ  ",
    "AirConditioningHumidness": "ความชื้น  ",
    "noData": "ยังไม่มีงานที่เพิ่มเข้ามา คลิกปุ่ม \"เพิ่ม\" เพื่อเพิ่มงาน  "
  },
  "rs232Translation": {
    "reliveBinding": "ยกเลิกการเชื่อมต่อ  ",
    "RELIVEBINDING": "ยกเลิกการเชื่อมต่อ",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "ชื่อ CBX ไม่สามารถเว้นว่างได้  ",
    "BrandNoNull": "ยี่ห้อไม่สามารถเว้นว่างได้  ",
    "ModelNoNull": "รุ่นไม่สามารถเว้นว่างได้  ",
    "AcNoNull": "การควบคุมเครื่องปรับอากาศไม่สามารถเว้นว่างได้  ",
    "RcNoNull": "รีโมทคอนโทรลไม่สามารถเว้นว่างได้"
  },
  "route": {
    customize: 'ปรับแต่ง',
    "InputSourcesLinkage": "การเชื่อมโยงแหล่งข้อมูล  ",
    "Automation": "อัตโนมัติ  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "กลุ่ม  ",
    "userMge": "ผู้ใช้  ",
    "authorityMge": "สิทธิ์  ",
    "roleMge": "บทบาท  ",
    "equipmentMge": "อุปกรณ์  ",
    "workstationMge": "เซิร์ฟเวอร์มีเดีย  ",
    "cloudDiskMge": "การควบคุมที่เก็บ  ",
    "operationLog": "บันทึกการดำเนินงาน  ",
    "setting": "การตั้งค่า  ",
    "resourceMge": "การจัดการทรัพยากร  ",
    "storageMge": "การจัดการที่เก็บ  ",
    "interfaceRename": "การเปลี่ยนชื่ออินเทอร์เฟซ  ",
    "processorManager": "ตัวจัดการโปรเซสเซอร์  ",
    "projectorCode": "การจัดการรหัสซีเรียล  ",
    "projectorCodeSetting": "การตั้งค่ารหัสซีเรียล  ",
    "RepairLog": "บันทึกการซ่อมแซม  ",
    "remoteControl": "รหัสรีโมทคอนโทรล  ",
    "acCode": "รหัสควบคุมเครื่องปรับอากาศ  ",
    "cardMge": "บัตร  ",
    "cardLog": "บันทึกการใช้บัตร  ",
    "cardManager": "ตัวจัดการบัตร  ",
    "meetingManager": "การประชุม  ",
    "meetingRoomManager": "การจัดการห้อง  ",
    "meetingDoorManager": "การจัดการแผง"
  },
  "navbar": {
    "logOut": "ออกจากระบบ  ",
    "dashboard": "แดชบอร์ด  ",
    "screenfull": "โหมดเต็มจอ  ",
    "language": "ภาษา  ",
    "userConsole": "คอนโซล Q-NEX  ",
    "BackTianwa": "กลับสู่ Tianwa"
  },
  "feedback": {
    "Feedback": "ข้อเสนอแนะ  ",
    "email": "โปรดทิ้งอีเมลของคุณเพื่อให้เราได้รับข้อเสนอแนะ  ",
    "content": "ยินดีต้อนรับและทิ้งข้อความเพื่อปรับปรุงผลิตภัณฑ์ของเรา ขอบคุณสำหรับความคิดเห็นของคุณ  ",
    "submit": "ส่ง  ",
    "emailNoEmpty": "อีเมลไม่สามารถเว้นว่างได้  ",
    "emailTrueRule": "โปรดกรอกอีเมลในรูปแบบที่ถูกต้อง  ",
    "contentNoEmpty": "เนื้อหาห้ามว่างเปล่า  ",
    "feedbackSuccess": "ข้อเสนอแนะสำเร็จ  ",
    "feedbackFailed": "ข้อเสนอแนะล้มเหลว  ",
    "emailNoChinese": "กล่องจดหมายไม่สามารถมีอักขระจีน  ",
    "emailLength": "ความยาวระหว่าง 5 ถึง 100 ตัวอักษร  ",
    "GroupNameLength": "ความยาวระหว่าง 1 ถึง 20 ตัวอักษร  ",
    "emailSpecialString": "กล่องกรอกข้อมูลนี้ไม่สามารถมีสตริงพิเศษ"
  },
  "login": {
    "title": "ยินดีต้อนรับ  ",
    "logIn": "เข้าสู่ระบบ  ",
    "username": "ชื่อผู้ใช้  ",
    "password": "รหัสผ่าน  ",
    "any": "ใดๆ  ",
    "thirdparty": "หรือเชื่อมต่อกับ  ",
    "thirdpartyTips": "ไม่สามารถจำลองในเครื่องท้องถิ่นได้ ดังนั้นโปรดผสานการจำลองธุรกิจของคุณเอง!!!  ",
    "placeholder": "[  \n  \"ชื่อผู้ใช้\",  \n  \"รหัสผ่าน\",  \n  \"รหัสยืนยัน\"  \n]  ",
    "userNameTitle": "ชื่อผู้ใช้ไม่ถูกต้อง!  ",
    "forget": "ลืมรหัสผ่าน?  ",
    "loginTitle0": "เข้าสู่ระบบสำเร็จ!  ",
    "loginTitle1000": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง!  ",
    "loginTitle1001": "ต้องกรอกชื่อผู้ใช้และรหัสผ่าน!  ",
    "loginTitle1002": "ต้องกรอกรหัสยืนยัน!  ",
    "loginTitle1003": "สถานะผู้ใช้ผิดกฎหมาย, การเข้าสู่ระบบล้มเหลว!  ",
    "loginTitle1004": "รหัสยืนยันไม่ถูกต้อง!  ",
    "loginTitle1005": "ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน!  ",
    "loginTitleUserName": "ต้องกรอกชื่อผู้ใช้!  ",
    "loginTitlePwd": "ต้องกรอกรหัสผ่าน!  ",
    "loginTitleVercode": "ต้องกรอกรหัสยืนยัน!  ",
    "errorLogin": "สิทธิ์ผู้ใช้ไม่เพียงพอ ไม่สามารถเข้าสู่ระบบได้!  ",
    "titleLoginNameFormat": "ต้องประกอบด้วยตัวอักษร หรืออักษรและตัวเลข"
  },
  "organizationMge": {
    "CanTDragTop": "ไม่สามารถย้ายไปที่ราก  ",
    "prefixCannotBeEmpty": "พรีฟิกซ์ของบัญชีผู้ดูแลระบบซุปเปอร์ไม่สามารถว่างเปล่าได้  ",
    "enterEnglishLetters": "พรีฟิกซ์ของบัญชีผู้ดูแลระบบซุปเปอร์สามารถกรอกได้เฉพาะตัวอักษรภาษาอังกฤษและตัวเลข  ",
    "dateNotSelected": "ยังไม่ได้เลือกวันที่เริ่มต้นของระยะเวลาการให้บริการสตรีมมิ่ง  ",
    "btnAddChild": "เพิ่มผู้ใต้บังคับบัญชา  ",
    "btnAddSibling": "เพิ่มพี่น้อง  ",
    "title": "เคล็ดลับ:  ",
    "againTitle": "กรุณายืนยันอีกครั้ง:  ",
    "sort": "จัดเรียง:  ",
    "realName": "ชื่อจริง:  ",
    "titleShooleRq": "ฟิลด์นี้ต้องกรอก  ",
    "titleShooleNub": "น้อยกว่า 100 ตัวอักษร  ",
    "schoolName": "ชื่อกลุ่ม:  ",
    "type": "ประเภทกลุ่ม:  ",
    "accountPrefix": "บัญชีผู้ดูแลระบบ:  ",
    "organization": "ผู้จัดจำหน่าย  ",
    "terminalMechanism": "ผู้ใช้ปลายทาง  ",
    "equipmentNum": "หมายเลขอุปกรณ์:  ",
    "organizationNum": "จำนวนกลุ่มเทอร์มินัล:  ",
    "adminName": "บัญชีผู้ดูแลระบบ:  ",
    "adminPwd": "รหัสผ่านผู้ดูแลระบบ:  ",
    "edit": "แก้ไข  ",
    "add": "เพิ่ม  ",
    "del": "ลบ  ",
    "addSuccess": "เพิ่มสำเร็จ  ",
    "addError": "เพิ่มล้มเหลว!  ",
    "editSuccess": "แก้ไขสำเร็จ  ",
    "editError": "แก้ไขล้มเหลว!  ",
    "delSuccess": "ลบสำเร็จ!  ",
    "delWarn": "ไม่สามารถลบกลุ่มนี้ที่มีอุปกรณ์ที่ผูกไว้  ",
    "delError": "ลบล้มเหลว!  ",
    "cancel": "ยกเลิก  ",
    "confirm": "ยืนยัน  ",
    "save": "บันทึก  ",
    "TrialWorkstation": "คุณอยู่ในสถานะการทดลองที่สามารถสตรีมและถ่ายทอดสดได้สูงสุด 3 อุปกรณ์เทอร์มินัลเท่านั้น  ",
    "Normal": "ปกติ  ",
    "NormalWorkstation": "ระยะเวลาการให้บริการสตรีมมิ่งของคุณตั้งแต่  ",
    "to": "ถึง  ",
    "Advent": "การมาถึง  ",
    "AdventWorkstationOne": "บริการสตรีมมิ่งของคุณจะหมดอายุในวันที่",
    "AdventWorkstationTwo": ", กรุณาติดต่อเอเจนต์ของคุณเพื่อขอต่ออายุทันเวลาเพื่อการใช้งานปกติ.  ",
    "Expired": "หมดอายุ  ",
    "ExpiredWorkstation": "บริการสตรีมมิ่งของคุณหมดอายุแล้ว กรุณาติดต่อเอเจนต์ของคุณเพื่อขอต่ออายุทันเวลา.  ",
    "admin": "ผู้ดูแลระบบ:  ",
    "serviceState": "บริการสื่อสตรีมมิ่ง:  ",
    "serviceStateLIST": "บริการสื่อสตรีมมิ่ง  ",
    "ValidityPeriod": "ระยะเวลาการใช้งาน:  ",
    "ValidityPeriodLIST": "ระยะเวลาการใช้งาน  ",
    "Trial": "ทดลองใช้งาน  ",
    "Permanent": "ถาวร  ",
    "AnnualBilling": "การเรียกเก็บเงินรายปี  ",
    "mediaValidityPeriod": "ระยะเวลาการใช้งาน:  ",
    "mediaValidityPeriodLIST": "ระยะเวลาการใช้งาน  ",
    "contactInformation": "ข้อมูลติดต่อ (สำหรับการเตือนการต่ออายุบริการสตรีมมิ่ง)  ",
    "company": "ชื่อบริษัท:  ",
    "email": "อีเมล์:  ",
    "phone": "โทรศัพท์:  ",
    "StartDate": "วันที่เริ่มต้น  ",
    "EndDate": "วันที่สิ้นสุด  ",
    "To": "ถึง  ",
    "TerminalName": "ชื่อผู้ใช้ปลายทาง  ",
    "Competence": "ผู้ดูแลระบบ  ",
    "operate": "การดำเนินการ  ",
    "statusFilter": "ตัวกรองสถานะ  ",
    "disableStreaming": "คุณแน่ใจหรือไม่ว่าต้องการปิดบริการสตรีมมิ่ง?  ",
    "enableStreaming": "คุณแน่ใจหรือไม่ว่าต้องการเปิดบริการสตรีมมิ่ง?  ",
    "disableStreamingContent": "เมื่อบริการสตรีมมิ่งถูกปิดใช้งาน กลุ่มจะไม่สามารถใช้ฟังก์ชันที่เกี่ยวข้องกับการออกอากาศและการออกอากาศสดได้  ",
    "enableStreamingContent": "กรุณาแก้ไขระยะเวลาการใช้งานสำหรับกลุ่มที่หมดอายุบริการสตรีมมิ่ง  ",
    "search": "กรอกชื่อองค์กร  ",
    "optionsYearZero": "กรุณาเลือก",
    "optionsYearOne": "หนึ่งปี  ",
    "optionsYearTwo": "สองปี  ",
    "optionsYearThree": "สามปี  ",
    "dialogName": "ชื่อ:  ",
    "detTitle": "การลบกลุ่มจะทำให้เนื้อหาทั้งหมดที่อยู่ภายใต้ถูกลบไปด้วย  ",
    "groupDelTitle": "คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้?  ",
    "delTitle": "ลบ?  ",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบจากฐานข้อมูล การดำเนินการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?  ",
    "delCancelButton": "ยกเลิก  ",
    "delConfirmButton": "ยืนยัน  ",
    "copySuccess": "เนื้อหาถูกคัดลอกไปยังคลิปบอร์ด  ",
    "copyError": "เบราว์เซอร์ไม่รองรับการคัดลอกอัตโนมัติ  ",
    "error1200": "ชื่อกลุ่มซ้ำ  ",
    "error1201": "การซ้ำซ้อนของกลุ่มหรือหมายเลข ID กลุ่ม  ",
    "error1202": "เกินจำนวนอุปกรณ์ที่สามารถเชื่อมต่อได้  ",
    "error1203": "ชื่อผู้ใช้ซ้ำ  ",
    "error1204": "มีการตั้งชื่อกลุ่มที่เหมือนกันในระดับเดียวกัน  ",
    "error1210": "โปรดใส่รหัสผ่านของผู้ดูแลระบบ  ",
    "warningGroup": "เลือกกลุ่ม!  ",
    "warningTerminal": "กลุ่มเทอร์มินัลไม่สามารถสร้างกลุ่มย่อยได้!  ",
    "account": "บัญชีซ้ำ  ",
    "titleOrganization": "หมายเหตุ: คำนำหน้าบัญชีถูกกำหนดในระดับองค์กร ผู้ใช้ทุกบัญชีภายใต้องค์กรนี้จะใช้คำนำหน้าเดียวกัน",
    "all": "ทั้งหมด"
  },
  "userMge": {
    "nickName": "ชื่อเล่น  ",
    "contentWithBrand": "กรอกยี่ห้อหรือรุ่น  ",
    "contentwithIp": "ค้นหาตามชื่ออุปกรณ์หรือที่อยู่ IP  ",
    "btnAdd": "ผู้ใช้ใหม่  ",
    "btnDelete": "ลบ  ",
    "btnDownload": "ดาวน์โหลดเทมเพลต  ",
    "btnImport": "การนำเข้าข้อมูลจำนวนมาก  ",
    "btnExport": "ดาวน์โหลด  ",
    "btnDisable": "ปิดการใช้งาน  ",
    "btnEnable": "เปิดใช้งาน  ",
    "accountType": "กรองตามบทบาท  ",
    "organizationName": "กรองตามกลุ่ม  ",
    "content": "ค้นหา  ",
    "systemAccount": "รหัสผู้ใช้  ",
    "idCardNumber": "รหัสพนักงาน  ",
    "customizeAccount": "บัญชีที่กำหนดเอง  ",
    "userName": "ชื่อ  ",
    "licenseNum": "หมายเลขใบอนุญาต  ",
    "phone": "โทรศัพท์  ",
    "email": "อีเมล  ",
    "role": "บทบาท  ",
    "status": "สถานะ  ",
    "affiliatedOrganization": "กลุ่ม  ",
    "roleTypeList1": "ผู้ใช้ทั่วไป  ",
    "roleTypeList2": "นักเรียน  ",
    "roleTypeList3": "ผู้ปกครอง  ",
    "roleTypeList101": "ผู้ดูแลตัวแทน  ",
    "roleTypeList102": "ผู้ดูแลระบบ  ",
    "roleTypeList301": "ผู้ดูแลระบบซูเปอร์  ",
    "userStatus1": "ใช้งาน  ",
    "userStatus2": "บล็อก  ",
    "userStatus3": "ลบ  ",
    "operate": "การกระทำ  ",
    "dialogName": "ชื่อเล่น:  ",
    "dialogUserName": "รหัสผู้ใช้:  ",
    "dialogUserNameDefined": "ชื่อผู้ใช้:  ",
    "dialogPassword": "รหัสผ่าน:  ",
    "dialogID": "รหัสพนักงาน:  ",
    "dialogRole": "บทบาท:  ",
    "dialogEmail": "อีเมล:  ",
    "dialogPhone": "โทรศัพท์:  ",
    "dialogGroup": "กลุ่ม:  ",
    "addUser": "ผู้ใช้ใหม่  ",
    "editUser": "แก้ไขผู้ใช้  ",
    "addSuccess": "เพิ่มสำเร็จ!  ",
    "addError": "เพิ่มไม่สำเร็จ!  ",
    "editSuccess": "แก้ไขสำเร็จ!  ",
    "editError": "แก้ไขไม่สำเร็จ!  ",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!  ",
    "cancel": "ยกเลิก  ",
    "confirm": "ยืนยัน  ",
    "save": "บันทึก  ",
    "tableDel": "ลบ  ",
    "tableEdit": "แก้ไข  ",
    "selectRoles": "เลือกบทบาท  ",
    "delTitle": "ลบ?  ",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบออกจากฐานข้อมูล การดำเนินการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?  ",
    "delCancelButton": "ยกเลิก  ",
    "delConfirmButton": "ยืนยัน  ",
    "titleRealNameRq": "ฟิลด์นี้ต้องกรอก  ",
    "titleRealNameFormat": "เลือกชื่อผู้ใช้ที่ประกอบด้วยอักษรและตัวเลขเท่านั้น  ",
    checkPasswordTitleTwo: 'กรุณาตั้งรหัสผ่านอย่างน้อย 6 ตัวอักษร โดยต้องมีตัวอักษรและตัวเลข สามารถใช้สัญลักษณ์พิเศษได้ (ไม่จำกัด)',
    checkPasswordTitle: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร และต้องไม่เป็นตัวเลขทั้งหมด',
    "titlePhoneFormat": "เบอร์โทรศัพท์สามารถกรอกได้เฉพาะตัวเลข, (), + และ -  ",
    "phoneFilled": "ต้องกรอกเบอร์โทรศัพท์  ",
    "titleEmaileFormat": "รูปแบบอีเมลไม่ถูกต้อง  ",
    "emaileFilled": "ต้องกรอกอีเมล  ",
    "titlUserNameDefinedNub": "ชื่อผู้ใช้ไม่สามารถเกิน 30 ตัวอักษร  ",
    "titlRealNameNub": "ชื่อไม่สามารถเกิน 30 ตัวอักษร  ",
    "titlRealNameField": "ต้องกรอกชื่อ  ",
    "thisPasswordField": "ต้องกรอกรหัสผ่าน  ",
    "titlPassWordNub": "รหัสผ่านต้องมีระหว่าง 6 ถึง 30 ตัวอักษร  ",
    "enableStatus": "เปิดใช้งานผู้ใช้  ",
    "stopStatus": "ปิดใช้งานผู้ใช้  ",
    "enableContent": "คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งานผู้ใช้?  ",
    "stopContent": "คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งานผู้ใช้?  ",
    "error1400": "ชื่อผู้ใช้มีอยู่แล้ว กรุณาลองใหม่  ",
    "error1401": "รหัสผู้ใช้มีอยู่แล้ว การดำเนินการล้มเหลว!  ",
    "error1402": "กลุ่มไม่พบ การนำเข้าล้มเหลว!  ",
    "error1403": "ข้อมูลผิดพลาด  ",
    "error1404": "สิทธิ์ไม่เพียงพอ  ",
    "selUser": "โปรดเลือกผู้ใช้!  ",
    "error1405": "ไม่สามารถดึงบทบาทได้  ",
    "error1406": "รูปแบบข้อมูลผู้ใช้ที่นำเข้าผิด  ",
    "error1407": "อีเมลมีอยู่แล้ว การดำเนินการล้มเหลว  ",
    "error1408": "เบอร์โทรศัพท์มีอยู่แล้ว การดำเนินการล้มเหลว  ",
    "error1900": "พารามิเตอร์ที่เข้าถึงว่างเปล่า  ",
    "error1610": "โปรดใช้บทบาทผู้ดูแลระบบเทอร์มินัลในการดำเนินการที่เกี่ยวข้อง  ",
    "errorOrgIdList": "กลุ่มไม่สามารถว่างเปล่าได้!  ",
    "Bindsucceeded": "การเชื่อมต่อสำเร็จ  ",
    "Bindfailed": "การเชื่อมต่อล้มเหลว  ",
    "tableuserName": "ชื่อผู้ใช้  ",
    "titleDevice": "อุปกรณ์  ",
    "bindDevice": "อุปกรณ์ที่เชื่อมต่อ  ",
    "Bindcontrollable": "เชื่อมต่ออุปกรณ์ที่สามารถควบคุมได้ตอนนี้?  "
  },
  "devicesMge": {
    mustChooseOne: 'เมื่อเลือกการควบคุมระยะไกลอัจฉริยะ ต้องเลือกคำสั่งควบคุมอย่างน้อยหนึ่งคำสั่ง',
    customName: 'ชื่อที่กำหนดเอง',
    "testAcCode": "ทดสอบรหัสควบคุม A/C ใหม่",
    "Online": "ออนไลน์",
    "Offline": "ออฟไลน์",
    "unBindConfirm": "ยืนยันการยกเลิกการผูก Serial",
    "unBindConfirm485": "ยืนยันการยกเลิกการผูก RS485",
    "notYetBoundRS232": "อุปกรณ์ยังไม่ได้เชื่อมต่อกับรหัส Serial คุณสามารถไปที่ อุปกรณ์ > รหัสควบคุม Serial เพื่อเพิ่ม",
    "RsFollowingFunctions": "สามารถทำฟังก์ชันต่อไปนี้ผ่านรหัส Serial:",
    "Unbind": "ยกเลิกการผูก",
    "Limit255": "ชื่อไฟล์มีสูงสุด 255 อักขระ",
    "clear": "ล้าง",
    "equipName": "ชื่ออุปกรณ์",
    "equipType": "ประเภท",
    "selectField": "โปรดเลือกไฟล์",
    "dialogTip": "*หากกล่องป้อนข้อมูลทางด้านขวาว่าง เนื้อหาทางด้านซ้ายจะแสดงโดยอัตโนมัติ",
    "dialogTipSingle": "*หากอุปกรณ์เดียวไม่ได้ตั้งชื่อ ให้ใช้ชื่อ \"ทั้งหมด\"",
    "cantDelTemplateOne": "CBX ของ",
    cantDelTemplateTwo: 'CBX ของอุปกรณ์ "{deviceName}" เป็นเทมเพลต คุณแน่ใจหรือไม่ว่าต้องการลบ?',
    "templateTitle": "การแทนที่แม่แบบ",
    "templateContentOne": "ชื่ออุปกรณ์ \"",
    "templateContentTwo": " ได้ถูกตั้งเป็นแม่แบบ CBX ทั่วไป คุณแน่ใจไหมว่าต้องการตั้งอุปกรณ์ปัจจุบันเป็นแม่แบบ?\n",
    "vcbNoTemplateNoSave": "ไม่สามารถบันทึกได้หากไม่มีแม่แบบ",
    "vcbAcControl": "เลือกอุปกรณ์ A/C",
    "vcbRemoteControl": "เลือกอุปกรณ์ควบคุมระยะไกล",
    "vcbPOWERControl": "การควบคุมพลังงาน",
    "vcbRS232Control": "การควบคุม Serial",
    "vcbIRControl": "การควบคุม IR",
    "vcbSetting": "การตั้งค่า CBX",
    "editVcb": "การแก้ไข CBX",
    "vcbName": "ชื่อ CBX",
    "iot": "การควบคุม CBX",
    "saveAsTemplate": "บันทึกเป็นแม่แบบ",
    saveAsTemplatereplenish: 'เลือกอุปกรณ์หลายเครื่องเพื่อใช้เทมเพลตนี้ในศูนย์ควบคุม',
    "Upload": "อัปโหลด",
    "Select": "เลือก",
    "InputDeviceID": "ป้อนรหัสอุปกรณ์",
    "editNameTips": "* เนื้อหาทางด้านซ้ายจะแสดงโดยอัตโนมัติเมื่อช่องป้อนข้อมูลทางด้านขวาว่าง",
    "_RS232A": "อินเตอร์เฟซหนึ่ง",
    "_RS232B": "อินเตอร์เฟซสอง",
    "institutionDirectory": "ไดเรกทอรีสถาบัน",
    "projectionScreenLinkageSetting": "การตั้งค่าการควบคุมหน้าจอโปรเจคเตอร์",
    "screenLiftingLinkageDisplaySwitch": "การควบคุมลิงค์หน้าจอโปรเจคเตอร์และการแสดงผล:",
    "stopLinkage": "ปิดใช้งาน (ควบคุมหน้าจอโปรเจคเตอร์แยกต่างหาก)",
    "Enable": "เปิดใช้งาน (ควบคุมหน้าจอโปรเจคเตอร์และการแสดงผลพร้อมกัน)",
    "btnAddDevice": "เพิ่มอุปกรณ์",
    "btnImportDevice": "นำเข้าอุปกรณ์เป็นจำนวนมาก",
    "btnDel": "ลบ",
    "btnEdit": "แก้ไข",
    "tableIpAddress": "ที่อยู่ IP",
    "MACAddress": "ที่อยู่ MAC",
    "firmwareVersion": "เวอร์ชันเฟิร์มแวร์",
    "NA": "ไม่สามารถใช้งาน",
    "tableDeviceName": "ชื่ออุปกรณ์",
    "tableStatus": "สถานะ",
    "tableVideoSwitch": "สวิตช์วิดีโอ",
    "tableAudio": "การกระจาย A/V",
    "tablePowerControl": "การควบคุมพลังงาน",
    "tableRS232": "การควบคุมอนุกรม",
    "tableIR": "การควบคุม IR",
    "tableRFIDCard": "บัตร IC",
    "tableControlPanel": "แผงควบคุม",
    "tableOrganization": "กลุ่ม",
    "tableActions": "การกระทำ",
    "dialogAddTitle": "เพิ่มอุปกรณ์",
    "dialogEditTitle": "แก้ไขอุปกรณ์",
    "dialogBatchAddTitle": "เพิ่มอุปกรณ์จำนวนมาก",
    "dialogBatchEditTitle": "แก้ไขอุปกรณ์จำนวนมาก",
    "btnCancel": "ยกเลิก",
    "Devices": "อุปกรณ์:",
    "ProjectorCode": "รหัส Serial:",
    "Group": "กลุ่ม:",
    "btnBatchAdd": "เพิ่มจำนวนมาก",
    "delTitle": "ลบ?",
    "delTitleContent": "ส่วนประกอบที่เลือกจะถูกลบออกจากฐานข้อมูล กระบวนการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "addError": "เพิ่มไม่สำเร็จ!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขไม่สำเร็จ!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!",
    "content": "ค้นหา",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "tableDel": "ลบ",
    "tableEdit": "แก้ไข",
    "selectRoles": "เลือกบทบาท",
    "selectType": "กรุณาเลือกประเภท",
    "selectDevices": "กรุณาเลือกอุปกรณ์",
    "titleRealNameRq": "ต้องกรอกข้อมูลในฟิลด์นี้",
    "titleRealNameNub": "น้อยกว่า 100 ตัวอักษร",
    "titlPassWordNub": "น้อยกว่า 15 ตัวอักษร",
    "error1900": "พารามิเตอร์ที่เข้าถึงเป็นค่าว่าง",
    "error2000": "เกินจำนวนอุปกรณ์ที่สามารถเชื่อมต่อได้สูงสุด",
    "error2001": "รหัสอุปกรณ์ที่นำเข้าไม่ถูกต้องหรือยังไม่ได้เข้าสู่ระบบ",
    "error2002": "ชื่ออุปกรณ์ที่นำเข้าซ้ำ",
    "error2003": "รหัสอุปกรณ์ที่นำเข้าถูกใช้แล้ว",
    "error2004": "ข้อผิดพลาดในการนำเข้าข้อมูล",
    "error2005": "ชื่อแบรนด์หรือรุ่นซ้ำกับข้อมูลที่มีอยู่ในระบบแล้ว กรุณาตั้งชื่อแบรนด์หรือรุ่นใหม่",
    "error2008": "อุปกรณ์นี้ถูกเชื่อมโยงกับกลุ่มอื่นแล้ว",
    "notDevicesName": "ชื่ออุปกรณ์ไม่สามารถเว้นว่างได้",
    "notDevicesNO": "รหัสอุปกรณ์ไม่สามารถเว้นว่างได้",
    "dialogDevicesName": "ชื่ออุปกรณ์:",
    "dialogDevicesID": "รหัสอุปกรณ์:",
    "dialogProjectorCode": "รหัส Serial:",
    "dialogGroup": "กลุ่ม:",
    "dialogSel": "กรุณาเลือก",
    "errorOrgIdList": "กลุ่มห้ามเป็นค่าว่าง!",
    "errorDevicesName": "ชื่ออุปกรณ์ห้ามเป็นค่าว่าง!",
    "errorDevicesNo": "รหัสอุปกรณ์ห้ามเป็นค่าว่าง!",
    "dialogTiltleDevices": "อุปกรณ์:",
    "uploadSuccess": "อัพโหลดสำเร็จ",
    "addSuccess": "เพิ่มสำเร็จ",
    "ChooseGroups": "เลือกกลุ่ม",
    "ChooseIcon": "เลือกไอคอน",
    "dialogDevicesTitle": "การตั้งค่าพารามิเตอร์ถูกใช้กับอุปกรณ์ดังต่อไปนี้",
    "backDevice": "กลับ",
    "bootSetting": "ตัวเลือกการเริ่มต้น",
    "nmpOpenSetting": "การตั้งค่าการเปิด",
    "npsOpenSetting": "การตั้งค่าการเปิด",
    "nmpPowerSettings": "การตั้งค่าพลังงาน",
    "npsPowerSettings": "การตั้งค่าพลังงาน",
    "nmpInterfaceSettings": "การตั้งค่าการเชื่อมต่อ",
    "npsInterfaceSettings": "การตั้งค่าการเชื่อมต่อ",
    "nmpDefaultChannel": "การตั้งค่าช่องทางเริ่มต้น",
    "nmpCloseSetting": "การตั้งค่าปิด",
    "npsCloseSetting": "การตั้งค่าปิด",
    "SwipeToStart": "เปิดล็อค (แตะการ์ดเพื่อปลดล็อค)",
    "ControlPanelToStart": "ปิดล็อค (การดำเนินการไม่จำกัด)",
    "Display": "แสดงผล",
    "External": "ภายนอก",
    "startingUpMethod": "เปิด/ปิดล็อคแผง:",
    "startWith": "เริ่มต้นด้วย:",
    "nmpstartWith": "เปิดซิงค์:",
    "nmpcloseWith": "ปิดซิงค์:",
    "RS232Tip": "เมื่อปิดแหล่งจ่ายไฟหลัก, ทั้งหมด 5 อินเตอร์เฟส Serial, รวมถึง Serial และสูงสุด 4 CBX, จะได้รับรหัสคำสั่งปิดที่เกี่ยวข้อง",

    startPowerTip: 'เมื่อเปิดเครื่อง อุปกรณ์ที่เชื่อมต่อกับพอร์ตไฟฟ้าของ CBX ทั้งหมดจะถูกเปิดพร้อมกัน',
    startAirTip: 'เมื่อเปิดเครื่อง เครื่องปรับอากาศทั้งหมดที่ผูกไว้จะเปิดผ่านอินฟราเรดของอุปกรณ์/CBX',
    startIrTip: 'เมื่อเปิดเครื่อง ส่งคำสั่งแบบลิงก์ผ่านอินฟราเรดของอุปกรณ์/CBX (เช่น ม่านลง โปรเจกเตอร์เปิด)',
    startRSTip: 'เมื่อเปิดเครื่อง ส่งคำสั่งเปิดผ่านพอร์ต Serial ของอุปกรณ์/CBX',
    CloseDisplayTip: 'อุปกรณ์ที่เชื่อมต่อกับพอร์ต DISPLAY จะปิดโดยอัตโนมัติเมื่อ NDP/NMP ปิด การตั้งค่านี้ควบคุมโดยเฟิร์มแวร์และไม่สามารถเปลี่ยนแปลงผ่านซอฟต์แวร์ได้',
    CloseExternalTip: 'อุปกรณ์ที่เชื่อมต่อกับพอร์ต EXTERNAL จะปิดโดยอัตโนมัติเมื่อ NDP/NMP ปิด การตั้งค่านี้ควบคุมโดยเฟิร์มแวร์และไม่สามารถเปลี่ยนแปลงผ่านซอฟต์แวร์ได้',
    ClosePowerTip: 'เมื่อปิดเครื่อง อุปกรณ์ที่เชื่อมต่อกับพอร์ตไฟฟ้าของ CBX ทั้งหมดจะถูกปิดพร้อมกัน',
    CloseAirTip: 'เมื่อปิดเครื่อง เครื่องปรับอากาศทั้งหมดที่ผูกไว้จะปิดผ่านอินฟราเรดของอุปกรณ์/CBX',
    CloseIrTip: 'เมื่อปิดเครื่อง ส่งคำสั่งแบบลิงก์ผ่านอินฟราเรดของอุปกรณ์/CBX (เช่น ม่านขึ้น โปรเจกเตอร์ปิด)',
    CloseRSTip: 'เมื่อปิดเครื่อง ส่งคำสั่งปิดผ่านพอร์ต Serial ของอุปกรณ์/CBX',
    npsOpenRS232Tip: 'เมื่อเปิดแหล่งจ่ายไฟหลัก พอร์ตอนุกรมทั้งสองของ NPS จะได้รับรหัสคำสั่งเปิดเครื่องที่เกี่ยวข้อง',
    "npsRS232Tip": "เมื่อปิดแหล่งจ่ายไฟหลัก, อินเตอร์เฟส Serial ของ NPS จะได้รับรหัสคำสั่งปิดที่เกี่ยวข้อง",
    "useCardTip": "หลังจากปลดล็อกการ์ด, พลังงานของอุปกรณ์จะถูกเปิดใช้งานโดยอัตโนมัติ",
    "npsCardTip": "หลังจากปลดล็อกการ์ด, พลังงานหลักของอุปกรณ์จะถูกเปิดใช้งานโดยอัตโนมัติ",
    "PowerOutageHandling": "การจัดการการขัดข้องของพลังงาน",
    "PowerOutageHandTip": "หากต้องการเข้าถึงต่อไปในกรณีที่ไฟฟ้าดับโดยไม่คาดคิด, เลือก \"ปลดล็อกเมื่อไฟฟ้าดับ\" มิฉะนั้น, เลือก \"ล็อคเมื่อไฟฟ้าดับ\" เพื่อจำกัดการเข้าถึง",
    "acSetting": "การตั้งค่า A/C",
    "ChooseType": "ประเภทอุปกรณ์",
    "ChooseBrand": "เลือกยี่ห้อ",
    "ChooseModel": "เลือกโมเดล",
    "btnConnectingTest": "ทดสอบการเชื่อมต่อ",
    "LockSetting": "การตั้งค่าล็อคไฟฟ้า",
    "ElectricLockType": "ประเภทล็อคไฟฟ้า:",
    "PowerUNLOCK": "ปลดล็อกเมื่อไฟฟ้าดับ",
    "PowerLOCK": "ล็อคเมื่อไฟฟ้าดับ",
    "none": "ไม่มี",
    "oddParity": "พาริตี้คี่",
    "EvenParity": "พาริตี้คู่",
    "LastSetting": "การตั้งค่าล่าสุด",
    "ElectricLockClosing": "การปิดล็อคไฟฟ้า:",
    "manualSwitch": "สวิตช์มือ",
    "Auto": "อัตโนมัติ (ใน",
    "projectorSetting": "การเลือกและผูกอุปกรณ์",
    "baudRate": "อัตรา Baud",
    "Parity": "พาริตี้",
    "ON": "เปิด",
    "OFF": "ปิด",
    "Channel1": "ช่อง 1",
    "Channel2": "ช่อง 2",
    "PowerOffDelay": "การหน่วงเวลาปิด",
    "second": "วินาที",
    "DefaultChannel": "ช่องเริ่มต้น",
    "HDMIA": "HDMI ออก A:",
    "HDMIB": "HDMI ออก B:",
    "HDMIC": "HDMI ออก C:",
    "btnSaveApply": "บันทึกและนำไปใช้กับ...",
    "btnSave": "บันทึก",
    "btnCustomize": "กำหนดเอง",
    "ACIsPowerTitle": "ตรวจสอบว่าเครื่องปรับอากาศเปิดอยู่หรือไม่?",
    "ACIsPowerContent": "กรุณาปิดเครื่องปรับอากาศก่อนทดสอบ ถ้ามันไม่เปิดได้สำเร็จ โปรดตรวจสอบให้แน่ใจว่าแบรนด์และรุ่นของเครื่องปรับอากาศถูกต้อง",
    "btnNextModel": "ไม่, ทดสอบรุ่นถัดไป",
    "btnYes": "ใช่",
    "errorConnecting": "การทดสอบการเชื่อมต่อล้มเหลว",
    "hot": "ร้อน",
    "_MAGNETICLOCK": "ล็อคอิเล็กทรอนิกส์",
    "_AIR": "เครื่องปรับอากาศ",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "การตั้งค่าการควบคุม IR",
    "acControlTitle": "เลือกอุปกรณ์ A/C:",
    "acControlTitleNew": "อุปกรณ์ A/C",
    "intelligentControlTitle": "เลือกอุปกรณ์ควบคุมระยะไกล:",
    "intelligentControlTitleNew": "อุปกรณ์ควบคุมระยะไกล",
    "btnACControlCode": "ระบุรหัสควบคุม A/C ใหม่",
    "btnAddRemoteControl": "รหัสรีโมทใหม่",
    "ACControlCodeTitle": "ระบุรหัสควบคุม A/C",
    "ACControlCodeseft1": "ระบุรหัส",
    "ACControlCodeseft2": "เพิ่มข้อมูล",
    "btnStartIdentify": "เริ่มต้น",
    "Identifysuccess": "ระบุตัวตนสำเร็จ!",
    "BeingIdentify": "กำลังวิเคราะห์...",
    "acBrand": "แบรนด์ A/C",
    "acModel": "รุ่น A/C",
    "IdentifyFailureTitle": "ไม่พบรหัส",
    "IdentifyFailureContent": "การระบุตัวตนล้มเหลว รุ่นนี้ไม่รองรับในขณะนี้ กรุณาลองใช้รีโมท",
    "btnTryAgain": "ลองอีกครั้ง",
    "btnJump": "ไปที่รีโมท",
    "ACrideo": "A/C",
    "ortherRideo": "อุปกรณ์อื่นๆ",
    "btnBack": "กลับ",
    "btnSortOut": "ไปที่แก้ไข",
    "remoteControlSeft1": "เลือกประเภทอุปกรณ์",
    "remoteControlSeft2": "เรียนรู้รหัส",
    "remoteControlSeft3": "เพิ่มข้อมูล",
    "addRemoteControlError": "ขออภัย, ไม่สามารถเรียนรู้รหัสเพิ่มเติมได้ กรุณาแก้ไขรหัสรีโมทที่มีอยู่ก่อน",
    "btnPrevious": "ก่อนหน้า",
    "btnNextStep": "ถัดไป",
    "remoteControlErrorTitle": "ไม่สามารถเรียนรู้รหัสได้",
    "remoteControlErrorContent1": "1. ตัวส่งอินฟราเรดไม่ถูกบล็อก",
    "remoteControlErrorContent2": "2. ไม่มีแสงสว่างที่รบกวนรอบๆ ตัวรับ",
    "remoteControlErrorContent3": "3. ตัวส่งอินฟราเรดติดตั้งถูกต้อง",
    "remoteControlErrorContent4": "4. รีโมททำงานได้ดี",
    "deviceItem1": "A/C",
    "deviceItem2": "โปรเจคเตอร์",
    "deviceItem3": "ทีวี",
    "deviceItem4": "พัดลม",
    "deviceItem5": "ไฟ",
    "deviceItem6": "อื่นๆ",
    "deviceItem7": "จอแบนอินเตอร์แอคทีฟ",
    "deviceItem8": "ระบบบันทึกการบรรยาย",
    "deviceItem9": "กล้อง PTZ",
    "RS232protocol": "โปรโตคอล Serial:",
    "btnRemoteControl": "เริ่มการเรียนรู้",
    "BeingIdentify1": "กำลังวิเคราะห์...",
    "Identifysuccess1": "สำเร็จ",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "ทีวี",
    "controllerType4": "พัดลม",
    "controllerType5": "ไฟ",
    "controllerType9": "อื่นๆ",
    "rqRemoteControlCode": "กรุณากรอกชื่อรหัสรีโมท",
    "rqBrand": "กรุณากรอกยี่ห้อของ A/C",
    "rqModel": "กรุณากรอกรุ่นของ A/C",
    "error2016": "ชื่อรีโมทซ้ำกัน กรุณากรอกชื่อใหม่",
    "RS232Setting": "การตั้งค่ารหัสซีเรียล",
    "IR232Setting": "การตั้งค่า IR",
    "SystemError": "ข้อผิดพลาดของระบบ กรุณาลองอีกครั้ง",
    "conditionerCodeContent": "ไม่พบรหัสเครื่องปรับอากาศ กรุณาลองใหม่",
    "remoteControlCodeContent": "ไม่พบรหัสรีโมท กรุณาลองใหม่",
    "btnRetry": "ลองใหม่",
    "Bindusers": "ผูกผู้ใช้",
    "tablebinduser": "ผูกผู้ใช้",
    "Refresh": "รีเฟรช",
    "Binduserlable": "ผูกผู้ใช้ที่สามารถควบคุมอุปกรณ์ได้ตอนนี้",
    "SaveApplySuccessfully": "บันทึกและใช้สำเร็จ",
    "DeviceType": "ประเภท:",
    "tableDeviceType": "ประเภท",
    "empty": "ว่างเปล่า",
    "sendCommand": "ส่งภายหลัง",
    "enable": "เปิดใช้งาน",
    "disable": "ปิดใช้งาน",
    "SYNCremoteControl": "ซิงค์กับรีโมท",
    "analysisfailed": "การวิเคราะห์ล้มเหลว กรุณาลองใหม่",

    "CBX": {
      "powerSupplyON": "เปิดเครื่อง",
      "powerSupplyOFF": "ปิดเครื่อง",
      "powerVcrON": "เริ่มบันทึก",
      "powerVcrOFF": "หยุดบันทึก",
      "lockScreenON": "ล็อคเปิด",
      "lockScreenOFF": "ล็อคปิด",
      "childLockON": "เปิดล็อคเด็ก",
      "childLockOFF": "ปิดล็อคเด็ก",
      "energySavingON": "เปิดโหมดประหยัดพลังงาน",
      "energySaving": "ประหยัดพลังงาน",
      "energySavingOFF": "ปิดโหมดประหยัดพลังงาน",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "ลำโพง",
      "brightAdjustment": "ความสว่าง",
      "other": "ฟังก์ชันอื่นๆ...",
      "volumeExample": "ฟังก์ชัน Serial ที่สมบูรณ์จำเป็นสำหรับความเข้ากันได้ทั้งหมดกับระบบการบันทึก",
      "functionCode": "ฟังก์ชัน:",
      "Name": "ชื่อ:",
      "controlCode": "รหัสการควบคุม:",
      "brand": "แบรนด์:",
      "model": "รุ่น:",
      "errorBrandName": "แบรนด์ไม่สามารถเป็นค่าว่างได้!",
      "errorModelName": "รุ่นไม่สามารถเป็นค่าว่างได้!"
    }

  },
  "roleMge": {
    "role1": "ผู้ใช้ทั่วไป",
    "role101": "ผู้ดูแลตัวแทน",
    "role102": "ผู้ดูแลระบบ",
    "role4": "บทบาทที่กำหนดเอง",
    "roleNew": "บทบาทใหม่",
    "btnAddRole": "เพิ่มบทบาท",
    "chooseUser": "เลือกผู้ใช้",
    "titleLevel": "ระดับคุณสมบัติการออกอากาศ:",
    "titleSettings": "การตั้งค่าอนุญาต:",
    "btnSave": "บันทึก",
    "btnDelete": "ลบ",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มไม่สำเร็จ!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขไม่สำเร็จ!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!",
    "V3_0_OrganizationManage": "การจัดการกลุ่ม",
    "V3_0_UserManage": "การจัดการผู้ใช้",
    "V3_0_DeviceManage": "การจัดการอุปกรณ์",
    "V3_0_CloudSpaceManage": "การจัดการพื้นที่คลาวด์",
    "V3_0_OrganizationManage_View": "ดู",
    "V3_0_OrganizationManage_Edit": "แก้ไข",
    "V3_0_UserManage_View": "ดู",
    "V3_0_UserManage_Edit": "แก้ไข",
    "V3_0_DeviceManage_AddDevice": "เพิ่มอุปกรณ์",
    "V3_0_DeviceManage_Operating": "การดำเนินการ",
    "V3_0_DeviceManage_Delete": "ลบ",
    "V3_0_DeviceManage_Edit": "แก้ไข",
    "V3_0_CloudSpaceManage_PersonalManage": "การจัดการคลาวด์ส่วนตัว",
    "V3_0_CloudSpaceManage_PublicManage": "การจัดการคลาวด์สาธารณะ",
    "V3_0_CloudSpaceManage_SpaceManage": "การจัดสรรพื้นที่",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "การดำเนินการ",
    "V3_0_CloudSpaceManage_PersonalManage_View": "ดู",
    "V3_0_CloudSpaceManage_PublicManage_View": "ดู",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "อัปโหลด",
    "V3_0_CloudSpaceManage_PublicManage_Download": "ดาวน์โหลด",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "ลบไฟล์",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "แก้ไขโฟลเดอร์",
    "delTitle": "ลบ?",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบออกจากฐานข้อมูล การดำเนินการนี้ไม่สามารถยกเลิกได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "btnAdd": "เพิ่มบทบาท",
    "RoleName": "ชื่อบทบาท:",
    "ManageRange": "ขอบเขตการจัดการ:",
    "ChooseUser": "เลือกผู้ใช้:",
    "PermissionSettings": "การตั้งค่าอนุญาต:",
    "BroadcastingPropertyLevel": "ระดับคุณสมบัติการถ่ายทอด",
    "ChooseGroups": "เลือกกลุ่ม",
    "ChooseTheUser": "เลือกผู้ใช้",
    "deleleTitle": "บทบาทใหม่ยังไม่ได้บันทึก หากคุณออกไป บทบาทจะถูกลบ คุณแน่ใจหรือไม่ว่าต้องการออก?",
    "Error1601": "ไม่สามารถใช้ผู้ดูแลระบบ",
    "Error1602": "ไม่สามารถรับบทบาทการอนุญาต",
    "Error1603": "เฉพาะผู้ดูแลระบบเท่านั้นที่สามารถเข้าถึงคุณสมบัติเหล่านี้",
    "Error1604": "ชื่อบทบาทไม่สามารถเว้นว่างได้",
    "Error1605": "กลุ่มไม่สามารถเว้นว่างได้",
    "Error1606": "บทบาทนี้มีอยู่แล้ว",
    "Error1607": "บทบาทที่กำหนดโดยระบบ ไม่สามารถแก้ไขได้",
    "Error1608": "การตั้งค่าบทบาทล้มเหลว",
    "Error1609": "บทบาทผู้ใช้ทั่วไปของระบบ ไม่สามารถแก้ไขได้",
    "Error1610": "โปรดใช้บทบาทผู้ดูแลระบบของเทอร์มินัลเพื่อดำเนินการที่เกี่ยวข้อง",
    "Error1611": "ไม่มีสิทธิ์ในการทำงานของบทบาทที่เกี่ยวข้อง"
  },
  "projectorDevicesMge": {
    "tipOne": "1. กรอกชื่อฟังก์ชันและรหัสควบคุม ตัวอย่างรหัสควบคุมใช้รูปแบบ HEX",
    "tipTwo": "2. อินเทอร์เฟซนี้สำหรับกำหนดค่าคำสอนอนุกรมเปิด/ปิดเครื่องเท่านั้น โปรดไปที่ 'การจัดการอุปกรณ์ / อุปกรณ์ / การดำเนินงาน / การตั้งค่าพลังงาน' เพื่อเปิดใช้งานฟังก์ชัน",
    "tipFunctionOne": "1. เลือกฟังก์ชันที่ใช้บ่อยจากรายการแบบดรอปดาวน์ ไอคอนที่สอดคล้องกันจะแสดงบนอินเทอร์เฟซการควบคุมแบบอนุกรมของแผงอัจฉริยะ",
    "tipFunctionTwo": "2. คำสั่ง 'POWER ON' และ 'POWER OFF' ใช้สำหรับการเชื่อมโยงอนุกรมเปิด/ปิดเครื่องของอุปกรณ์ หน้านี้กำหนดค่ารหัสควบคุมเท่านั้น โปรดไปที่ 'การจัดการอุปกรณ์ / อุปกรณ์ / การดำเนินงาน / การตั้งค่าพลังงาน' เพื่อเปิดใช้งานฟังก์ชันเชื่อมโยง",
    "ListRS232functions": "รายการฟังก์ชันการควบคุมแบบอนุกรม",
    "Customizefunctionlist": "ปรับแต่งรายการฟังก์ชัน",
    "btnAddProjectorCode": "เพิ่มรหัสอนุกรม",
    "btnDel": "ลบ",
    "inputSeach": "ค้นหา",
    "btnEdit": "แก้ไข",
    "cancel": "ล้าง",
    "confirm": "ยืนยัน",
    "tableName": "ชื่อรหัส",
    "tablersType": "ประเภทอุปกรณ์:",
    "tablersTypeTable": "ประเภทอุปกรณ์",
    "tableModel": "รุ่น",
    "tableBrand": "ยี่ห้อ",
    "tableActions": "การกระทำ",
    "dialogAddTitle": "เพิ่มรหัส Serial",
    "dialogEditTitle": "แก้ไขรหัส Serial",
    "brand": "ชื่อแบรนด์:",
    "model": "รุ่น:",
    "baudRate": "อัตราการส่งข้อมูล:",
    "parity": "พาริตี:",
    "powerOn": "เปิด",
    "powerOff": "ปิด",
    "pgrInput1": "ช่อง 1",
    "pgbInput2": "ช่อง 2",
    "delTitle": "ลบ?",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบออกจากฐานข้อมูล การดำเนินการนี้ไม่สามารถยกเลิกได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "content": "ค้นหา",
    "operate": "การกระทำ",
    "tableDel": "ลบ",
    "tableEdit": "แก้ไข",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มล้มเหลว!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขล้มเหลว!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบล้มเหลว!",
    "selectTitle": "โปรดเลือก Serial!",
    "selectCode": "เลือก Serial",
    "none": "ไม่มี",
    "oddParity": "พาริตีคี่",
    "EvenParity": "พาริตีคู่"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "การจัดการกลุ่ม",
    "V3_0_UserManage": "การจัดการผู้ใช้",
    "V3_0_DeviceManage": "การจัดการอุปกรณ์",
    "V3_0_CloudSpaceManage": "การจัดการพื้นที่คลาวด์",
    "V3_0_OrganizationManage_View": "ดู",
    "V3_0_OrganizationManage_Edit": "แก้ไข",
    "V3_0_UserManage_View": "ดู",
    "V3_0_UserManage_Edit": "แก้ไข",
    "V3_0_DeviceManage_AddDevice": "เพิ่มอุปกรณ์",
    "V3_0_DeviceManage_Operating": "การทำงาน",
    "V3_0_DeviceManage_Delete": "ลบ",
    "V3_0_DeviceManage_Edit": "แก้ไข",
    "V3_0_DeviceManage_RepairLog": "บันทึกการซ่อม",
    "V3_0_CloudSpaceManage_PersonalManage": "การจัดการคลาวด์ส่วนบุคคล",
    "V3_0_CloudSpaceManage_PublicManage": "การจัดการคลาวด์สาธารณะ",
    "V3_0_CloudSpaceManage_SpaceManage": "การจัดการพื้นที่คลาวด์",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "การทำงาน",
    "V3_0_CloudSpaceManage_PersonalManage_View": "ดู",
    "V3_0_CloudSpaceManage_PublicManage_View": "ดู",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "อัปโหลด",
    "V3_0_CloudSpaceManage_PublicManage_Download": "ดาวน์โหลด",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "ลบ",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "แก้ไข",
    "delTitle": "ลบ?",
    "delTitleContent": "องค์ประกอบที่เลือกจะถูกลบออกจากฐานข้อมูล กระบวนการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "content": "ค้นหา",
    "operate": "การดำเนินการ",
    "tableDel": "ลบ",
    "tableEdit": "แก้ไข",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มไม่สำเร็จ!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขไม่สำเร็จ!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!",
    "selectTitle": "กรุณาเลือก Serial!"
  },
  "workstationMge": {
    "priorChoice": "การตั้งค่าการออกอากาศ:",
    "SpeedPriority": "ลำดับความสำคัญของความเร็ว",
    "SyncPriority": "ลำดับความสำคัญของการซิงโครไนซ์เฟรม",
    "SpeedPriorityTip": "หลังจากส่งคำแนะนำการออกอากาศ AV แล้ว อุปกรณ์ Q-NEX สามารถทำการเล่นได้ภายในเวลาแค่ 3-5 วินาที ความสำคัญของความเร็วจะได้รับการแนะนำเมื่อเซิร์ฟเวอร์สื่อทำงานใน LAN",
    "SyncPriorityTip": "หลังจากส่งคำแนะนำการออกอากาศ AV แล้ว อุปกรณ์ Q-NEX สามารถทำการเล่นพร้อมกันกับเวลาแคชประมาณ 8-12 วินาที",
    "btnAddMedia": "เพิ่มเซิร์ฟเวอร์สื่อ",
    "btnBack": "ย้อนกลับ",
    "tableMediaLibId": "ID ของเซิร์ฟเวอร์สื่อ",
    "tableMediaLibName": "ชื่อเซิร์ฟเวอร์สื่อ",
    "tableState": "สถานะเครือข่าย",
    "tableBindingUsers": "ผู้ใช้ที่ผูก",
    "tableLiveAddress": "ที่อยู่การออกอากาศ",
    "tableAddress": "ที่อยู่การสตรีม",
    "tableOperate": "การดำเนินการ",
    "tableDel": "ลบ",
    "tableEdit": "แก้ไข",
    "titleMediaStation": "ที่อยู่การออกอากาศ",
    "titleLiveStation": "ที่อยู่การสตรีม:",
    "radioPublic": "สาธารณะ",
    "radioPrivate": "ส่วนตัว",
    "btnSave": "บันทึก",
    "titleUsers": "ผู้ใช้",
    "titleCanBe": "สามารถผูกได้",
    "titleHaveBeen": "ผูกแล้ว",
    "titleMore": "ต้องการเพิ่มเพิ่มเติมหรือไม่?",
    "btnAdd": "เพิ่ม",
    "content": "ค้นหา",
    "tableName": "ชื่อ",
    "tableUserName": "ชื่อผู้ใช้",
    "operate": "การดำเนินการ",
    "affiliatedOrganization": "กลุ่ม",
    "dialogTitle": "เพิ่มเซิร์ฟเวอร์สื่อใหม่",
    "dialogTitleEdit": "แก้ไขเซิร์ฟเวอร์สื่อใหม่",
    "dialogItemName": "ชื่อ:",
    "dialogItemId": "ID:",
    "dialogItemIp": "ที่อยู่การออกอากาศ:",
    "titleSelectUsers": "เลือกผู้ใช้",
    "selectMedia": "กรุณาเลือกสื่อ",
    "delTitle": "คุณแน่ใจหรือไม่ว่าต้องการลบ?",
    "delMediaLibTitle": "ยืนยันการลบ?",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบออกจากฐานข้อมูล การดำเนินการนี้ไม่สามารถยกเลิกได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delTitleMediaLibContent": "การดำเนินการลบจะทำให้ข้อมูลที่เกี่ยวข้องถูกลบออกและไม่สามารถกู้คืนได้",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "selectDevices": "กรุณาเลือกอุปกรณ์",
    "selectUser": "กรุณาเลือกผู้ใช้",
    "addUser": "เพิ่มผู้ใช้",
    "editUser": "แก้ไขผู้ใช้",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มไม่สำเร็จ!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขไม่สำเร็จ!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "error2500": "เกินจำนวนอุปกรณ์สูงสุดที่สามารถเชื่อมต่อกับสถานีงานปัจจุบัน",
    "DeviceName": "ชื่ออุปกรณ์",
    "AssociatedUserManagement": "การจัดการผู้ใช้ที่เกี่ยวข้อง",
    "btnDel": "ลบ",
    "errorMsgId": "ไม่พบ ID นี้",
    "LiveStreaming": "ที่อยู่การสตรีม:",
    "NoFoundMediaId": "ไม่สามารถรับ ID ของเซิร์ฟเวอร์สื่อได้",
    "AlreadyConnectedOrg": "เซิร์ฟเวอร์มีเดียเชื่อมต่อกับองค์กรอื่นแล้ว",
    "AlreadyBoundMedia": "องค์กรนี้ได้เชื่อมโยงเซิร์ฟเวอร์มีเดียแล้วและไม่สามารถเชื่อมโยงเซิร์ฟเวอร์เพิ่มได้",
    "DeleteSecondaryConfirmation": "ข้อมูลไม่สามารถกู้คืนได้หลังจากการลบเซิร์ฟเวอร์มีเดีย กรุณายืนยันอีกครั้ง"
  },
  "cloudDiskMge": {
    "totalStorage": "การจัดเก็บทั้งหมด",
    "GetMore": "ขอเพิ่มพื้นที่",
    "StorageSpace": "พื้นที่การจัดเก็บ",
    "Adjustment": "การปรับแต่ง",
    "moreSpace": "ขอเพิ่มพื้นที่การจัดเก็บ",
    "PublicStorage": "พื้นที่จัดเก็บสาธารณะ",
    "PublicStorageUsed": "พื้นที่จัดเก็บสาธารณะที่ใช้",
    "PublicStorageLasted": "พื้นที่จัดเก็บสาธารณะที่เหลือ",
    "IndividualStorageUsed": "พื้นที่จัดเก็บส่วนตัวที่ใช้",
    "IndividualStorageLasted": "พื้นที่จัดเก็บส่วนตัวที่เหลือ",
    "storageSpace": "การปรับแต่งพื้นที่การจัดเก็บ",
    "tableUserName": "ชื่อผู้ใช้",
    "tableUsedSpace": "พื้นที่ที่ใช้",
    "tableAvailableSpace": "พื้นที่ที่พร้อมใช้งาน",
    "tableActiveTime": "เวลาที่ใช้งานล่าสุด",
    "tableOperate": "การดำเนินการ",
    "cleanup": "หมายเหตุการทำความสะอาด",
    "IndividualStorageSpaceAdjustment": "การปรับแต่งพื้นที่การจัดเก็บส่วนตัว",
    "titleTotal": "รวม",
    "PublicDisk": "คลาวด์สาธารณะ",
    "IndividualDisk": "คลาวด์ส่วนตัว",
    "PerUser": "ต่อผู้ใช้",
    "UsersInTotal": "จำนวนผู้ใช้ทั้งหมด",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มล้มเหลว!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขล้มเหลว!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบล้มเหลว!",
    "error3000": "การดำเนินการล้มเหลวเนื่องจากขนาดรวมของพื้นที่จัดเก็บเกินขีดจำกัด",
    "error3003": "การดำเนินการล้มเหลว กรุณาตรวจสอบว่าได้ตั้งค่าเซิร์ฟเวอร์มีเดียหรือไม่",
    "IndividualStorage": "พื้นที่จัดเก็บส่วนตัว",
    "NoteToCleanup": "หมายเหตุการทำความสะอาด",
    "updatePersonalSuccess": "พื้นที่การจัดเก็บบนคลาวด์ของคุณจะเต็ม กรุณาทำความสะอาดให้ทันเวลา",
    "updatePersonalSuccess1": "แก้ไขและบันทึกสำเร็จ",
    "storageUsage": "การใช้งานพื้นที่จัดเก็บส่วนตัว",
    "bindIndividualstorage": "ผู้ใช้ที่ได้รับอนุญาตให้มีพื้นที่จัดเก็บบนคลาวด์ส่วนตัว",
    "UserIndividualstorage": "ผู้ใช้ที่ตั้งค่าพื้นที่จัดเก็บบนคลาวด์ส่วนตัวแล้ว",
    "Notificationsuccessfully": "การแจ้งเตือนส่งสำเร็จ",
    "Notificationfailed": "การส่งการแจ้งเตือนล้มเหลว",
    "tableName": "ชื่อ",
    "userID": "ID ผู้ใช้"
  },
  "dashboard": {
    "exportPdf": "ส่งออก PDF",
    "or": "-",
    "warrantyCompletionRate": "อัตราการซ่อม",
    "frequencyOfEachModule": "เปอร์เซ็นต์การซ่อมของแต่ละโมดูลฟังก์ชัน",
    "repairHandling": "สถานะการประมวลผลการซ่อม",
    "sourceSwitchInput": "สวิตช์อินพุต",
    "micVol": "ระดับเสียงไมโครโฟน",
    "volumeSpeaker": "ระดับเสียงลำโพง",
    "airAonditioner": "เครื่องปรับอากาศ",
    "Curtain": "หน้าจอโปรเจคเตอร์",
    "remoteControlIntelligent": "รีโมทคอนโทรล",
    "RS232Control": "การควบคุม Serial",
    "lockElectronic": "ล็อคอิเล็กทรอนิกส์",
    "Repairreportcompleted": "ซ่อมแล้ว",
    "Totalnumberofrepairsreported": "การซ่อมทั้งหมด",
    "Warrantycompletionrate": "อัตราการซ่อม",
    "startDate": "วันที่เริ่มต้น",
    "endDate": "วันที่สิ้นสุด",
    "year": "ปี",
    "month": "เดือน",
    "dayTian": "วัน",
    "placeholderDate": "เลือกวันที่",
    "placeholderDateTime": "เลือกเวลา",
    "devicesNub": "อุปกรณ์",
    "userNub": "ผู้ใช้",
    "powerNub": "กำลังไฟ (KW/H)",
    "storageUsed": "การใช้พื้นที่จัดเก็บ (%)",
    "userLoginDevice": "ช่วงเวลาการเข้าสู่ระบบของผู้ใช้",
    "devicePowerConsumption": "การใช้ไฟฟ้ารายวันของอุปกรณ์ทั้งหมด",
    "externalDeviceUsageTime": "การใช้เครื่องมือภายนอก",
    "equipmentRunningTime": "การใช้เครื่องมือปลายทาง",
    "cloudStorageSpace": "การใช้พื้นที่จัดเก็บ",
    "powerConsumptionPort": "การใช้พลังงานของแต่ละพอร์ตพลังงาน",
    "mostPopularFile": "ไฟล์ที่ได้รับความนิยมสูงสุด",
    "commonFunctions": "ฟังก์ชั่นที่ใช้บ่อย",
    "commonlyUsed": "วิธีการออกอากาศที่ใช้บ่อยที่สุด",
    "fileName": "ชื่อไฟล์",
    "usageCount": "จำนวนการใช้งาน",
    "electricityConsumption": "การใช้ไฟฟ้า",
    "publicStorageUsed": "พื้นที่จัดเก็บสาธารณะที่ใช้",
    "publicStorageLasted": "พื้นที่จัดเก็บสาธารณะที่เหลือ",
    "individualStorageUsed": "พื้นที่จัดเก็บส่วนตัวที่ใช้",
    "individualStorageLasted": "พื้นที่จัดเก็บส่วนตัวที่เหลือ",
    "notification": "การแจ้งเตือน",
    "audioBroadcast": "การออกอากาศเสียง",
    "videoBroadcast": "การออกอากาศวิดีโอ",
    "ac": "เครื่องปรับอากาศ",
    "hDMISwitch": "สวิตช์ HDMI",
    "powerControl": "การควบคุมพลังงาน",
    "powercontrol": "การควบคุมพลังงาน",
    "Lock": "ล็อค",
    "volumeAdjust": "ปรับระดับเสียง",
    "projectionScreen": "หน้าจอโปรเจคเตอร์",
    "today": "วันนี้",
    "yesterday": "เมื่อวาน",
    "thisWeek": "สัปดาห์นี้",
    "lastWeek": "สัปดาห์ที่แล้ว",
    "lastMonth": "เดือนที่แล้ว",
    "thisMonth": "เดือนนี้",
    "times": "ครั้ง",
    "usage": "จำนวนการใช้งาน",
    "eachrTitle": "นาที",
    "total": "ทั้งหมด",
    "NMPSystemissue": "ปัญหาระบบ NMP",
    "displayPower": "ปัญหาจากอุปกรณ์ภายนอก NMP",
    "externalPower": "ปัญหาระบบ MBX",
    "screen": "ปัญหาจากอุปกรณ์ภายนอก MBX",
    "TotalRepairs": "จำนวนการซ่อมทั้งหมด",
    "Repaired": "ซ่อมแล้ว",
    "Unrepaired": "ยังไม่ได้ซ่อม",
    "day": "วัน",
    "Minutes": "นาที",
    "powerConsumption": "นาที",
    "Date": "วันที่",
    "kw": "KW",
    "month1": "จันทร์",
    "month2": "อังคาร",
    "month3": "พุธ",
    "month4": "พฤหัสบดี",
    "month5": "ศุกร์",
    "month6": "เสาร์",
    "month7": "อาทิตย์",
    "enmonth1": "ม.ค.",
    "enmonth2": "ก.พ.",
    "enmonth3": "มี.ค.",
    "enmonth4": "เม.ย.",
    "enmonth5": "พ.ค.",
    "enmonth6": "มิ.ย.",
    "enmonth7": "ก.ค.",
    "enmonth8": "ส.ค.",
    "enmonth9": "ก.ย.",
    "enmonth10": "ต.ค.",
    "enmonth11": "พ.ย.",
    "enmonth12": "ธ.ค.",
    "noData": "ไม่มีข้อมูล"
  },
  "input": {
    "fivedigits": "กรุณากรอกจำนวนเต็มบวกภายใน 5 หลัก",
    "titlUserNameField": "ต้องกรอกชื่อผู้ใช้",
    "thisField": "ต้องกรอกข้อมูลในฟิลด์นี้",
    "ChooseGroup": "เลือกกลุ่ม",
    "placeholder": "เลือก",
    "placeholder_type": "กรุณาเลือกประเภทการควบคุมอุปกรณ์",
    "titlRealNameField": "ต้องกรอกรหัสผ่าน",
    "thisPasswordField": "ต้องกรอกรหัสผ่าน",
    "titlPassWordNub": "น้อยกว่า 15 ตัวอักษร",
    "Post": "เฉพาะตัวเลข",
    "passwordNoChinese": "ไม่สามารถกรอกอักขระภาษาจีนในกล่องนี้ได้"
  },
  "transfer": {
    "all": "ทั้งหมด",
    "Choose": "เลือก",
    "Selected": "ที่เลือก",
    "Subordinate": "อยู่ภายใต้"
  },
  "setting": {
    limitPngGif: 'รองรับเฉพาะไฟล์ PNG / GIF เท่านั้น',
    limit3M: 'ขนาดรูปภาพต้องไม่เกิน 3MB',
    setting_door_Wallpaper_text: 'ขนาดรูปภาพที่แนะนำ: 1280x800 รูปแบบ PNG หรือ GIF',

    "reduction": "คืนค่า",
    "limitJpg": "โปรไฟล์รูปภาพที่อัปโหลดได้สามารถเป็นไฟล์ PNG เท่านั้น!",
    "limit2M": "ขนาดของโปรไฟล์รูปภาพที่อัปโหลดไม่สามารถเกิน 2MB!",
    "choseFile": "เลือกไฟล์",
    "textOne": "1. ขนาดโลโก้ที่แนะนำ: ขนาด 117*40, ในรูปแบบ PNG",
    "textTwo": "2. หลังจากอัปโหลดเสร็จแล้ว กรุณาไปที่แผงสัมผัส และตรวจสอบให้แน่ใจว่าแผงสัมผัสเชื่อมต่อกับอินเทอร์เน็ต แล้วคลิกที่โลโก้เดิมเพื่อทำการอัปเดต",
    "customizeLogo": "การตั้งค่าโลโก้แผงสัมผัส",
    "addSuccess": "ตั้งค่าเสร็จสิ้น!",
    "settingIp": "การตั้งค่า IP สำหรับการจัดเก็บไฟล์",
    "ServerIP": "ที่อยู่ IP ของเซิร์ฟเวอร์:",
    "ServerPort": "พอร์ตเซิร์ฟเวอร์:",
    "btnSave": "บันทึก",
    "TimeZoneSetting": "การตั้งค่าโซนเวลา",
    "CurrentTime": "เวลาปัจจุบัน:",
    "CurrentTimeZone": "โซนเวลาปัจจุบัน:",
    "httpsSetting": "การจัดเก็บไฟล์:",
    "utcName": "เวลาเฉลี่ยของกรีนิช UTC/GMT",
    "utc0": "เวลาเฉลี่ยของกรีนิช, สหราชอาณาจักร, ลิสบอน, ทอร์ชฮาเวน, ลอนดอน, ดับลิน, เอดินเบอระ",
    "utc0_5": "",
    "utc1": "ยุโรปกลาง, แอฟริกาตะวันตก, แอฟริกากลางตะวันตก, เยอรมนี, ไอร์แลนด์, ฝรั่งเศส, อัมสเตอร์ดัม, อิตาลี, เบอร์ลิน, โรม, สเปน, ปราก, เบลเกรด, บรัสเซลส์, ปารีส, มาดริด, ตูนิเซีย, กาบอง, โมร็อกโก",
    "utc1_5": "",
    "utc2": "ยุโรปตะวันออก, แอฟริกากลาง, ตุรกี, อิสราเอล, แอฟริกาใต้, อิสตันบูล, ไคโร, เอเธนส์, ดามัสกัส",
    "utc2_5": "",
    "utc3": "แอฟริกาตะวันออก, รัสเซีย, แบกแดด, คูเวต, มอสโก, เซนต์ปีเตอร์สเบิร์ก",
    "utc3_5": "อิหร่าน",
    "utc4": "อาบูดาบี, ทบิลิซี, ดูไบ, มอริเชียส, พอร์ตหลุยส์",
    "utc4_5": "อัฟกานิสถาน",
    "utc5": "ปากีสถาน, เติร์กเมนิสถาน, มัลดีฟส์, อุซเบกิสถาน, อาร์เมเนีย, ทาจิกิสถาน อินเดีย, มุมไบ, นิวเดลี, บังกาลอร์, โกลกาตา",
    "utc5_5": "อินเดีย, ศรีลังกา",
    "utc6": "โนโวซิบบิร์สค์, คีร์กีซสถาน, บังกลาเทศ, ภูฏาน",
    "utc6_5": "เกาะโคโคส ออสเตรเลีย, เวียดนาม",
    "utc7": "ไทย, กรุงเทพ, ฮานอย, จาการ์ตา",
    "utc7_5": "",
    "utc8": "จีน, มาเลเซีย, ฟิลิปปินส์, สิงคโปร์, ไต้หวันจีน, มาเก๊าจีน, ฮ่องกงจีน",
    "utc8_5": "",
    "utc9": "ญี่ปุ่น, เกาหลีใต้, โตเกียว, โซล, ซัปโปโร, โอซาก้า, ติมอร์ตะวันออก",
    "utc9_5": "เวลามาตรฐานกลางออสเตรเลีย",
    "utc10": "ออสเตรเลีย, วลาดีวอสต็อก, กวม, แคนเบอร์รา, เมลเบิร์น, ซิดนีย์, ปาปัวนิวกินี",
    "utc10_5": "เกาะลอร์ดเฮาแห่งนิวเซาท์เวลส์, ออสเตรเลีย",
    "utc11": "หมู่เกาะโซโลมอน, เกาะซาคาลิน",
    "utc11_5": "เกาะนอร์ฟอล์ก, ออสเตรเลีย",
    "utc12": "นิวซีแลนด์, ออคแลนด์, เวลลิงตัน, ฟิจิ, นิวซีแลนด์, นาอูรู",
    "utc12_5": "",
    "utc13": "เคปเวิร์ด, อะซอเรส",
    "utc13_5": "",
    "utc14": "จอร์เจียใต้, เฟอร์นันโดเดอนอร์ออญา",
    "utc14_5": "",
    "utc15": "บราซิล, ซันติอาโก, เอลซัลวาดอร์, บราซิเลีย, อุรุกวัย, อาร์เจนตินา, ซูรินาเม",
    "utc15_5": "เวลามาตรฐานของนิวฟาวด์แลนด์",
    "utc16": "เวเนซูเอลา, โบลิเวีย, ปารากวัย, ชิลี",
    "utc16_5": "เวเนซูเอลา",
    "utc17": "เวลามาตรฐานตะวันออก (สหรัฐอเมริกาและแคนาดา), โคลอมเบีย, โตรอนโต, เอกวาดอร์, เปรู, คิวบา, นิวยอร์ก, แฮมิลตัน, ซานดิเอโก",
    "utc17_5": "",
    "utc18": "เวลามาตรฐานกลางสหรัฐอเมริกาและแคนาดา, เม็กซิโกซิตี้, มอนเตร์เรย์, ชิคาโก, ฮูสตัน, นิวออร์ลีนส์, เมมฟิส",
    "utc18_5": "",
    "utc19": "เวลามาตรฐานภูเขา, อริโซนา, มาซาตลัน, ฟีนิกซ์, ซอลต์เลคซิตี้, เดนเวอร์, อีดมอนตัน",
    "utc19_5": "",
    "utc20": "เวลามาตรฐานมหาสมุทรแปซิฟิก, ลอสแองเจลิส, ซานฟรานซิสโก, แวนคูเวอร์, ซีแอตเทิล, ลาสเวกัส",
    "utc20_5": "",
    "utc21": "อลาสกา",
    "utc21_5": "โปลินีเซียฝรั่งเศส, หมู่เกาะมาร์เกซัส",
    "utc22": "ฮาวาย",
    "utc22_5": "",
    "utc23": "ซามัว, นิอูเอ",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "ชื่ออุปกรณ์:",
    "Time": "เวลา:",
    "startDate": "วันที่เริ่มต้น",
    "endedDate": "วันที่สิ้นสุด",
    "or": "-",
    "Problem": "ปัญหา:",
    "btnSearch": "ค้นหา",
    "tableNO": "ไม่",
    "tableDeviceName": "ชื่ออุปกรณ์",
    "tableGroup": "กลุ่ม",
    "tableStatus": "สถานะ",
    "tableDeliveredTime": "เวลาจัดส่ง",
    "tableSubmitter": "ผู้ส่ง",
    "tableUpdatingTime": "เวลาปรับปรุง",
    "tableProblem": "ปัญหา",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "การตอบกลับจากผู้ดูแล",
    "tableAttachment": "ไฟล์แนบ",
    "state0": "ส่งมอบแล้ว",
    "state1": "อยู่ในกระบวนการ",
    "state2": "เสร็จสมบูรณ์",
    "Problem100": "ทั้งหมด",
    "Problem0": "ปัญหาระบบ",
    "Problem1": "ปัญหาจากอุปกรณ์ภายนอก",
    "ProblemType": "",
    "ProblemType0": "การควบคุมพลังงาน",
    "ProblemType1": "สวิตช์ HDMI",
    "ProblemType2": "ไมโครโฟน",
    "ProblemType3": "ลำโพง",
    "ProblemType4": "เครื่องปรับอากาศ",
    "ProblemType5": "หน้าจอโปรเจคเตอร์",
    "ProblemType6": "ล็อคไฟฟ้า",
    "ProblemType7": "การถ่ายทอดเสียง/วิดีโอ",
    "ProblemType8": "การควบคุม IR",
    "ProblemType9": "การควบคุม Serial",
    "dialogDeviceName": "ชื่ออุปกรณ์",
    "dialogDeviceID": "รหัสอุปกรณ์",
    "dialogGroup": "กลุ่ม",
    "dialogSubmitter": "ผู้ส่ง",
    "dialogStatus": "เลือกสถานะ",
    "dialogProblem": "ปัญหา",
    "dialogNotes": "บันทึก",
    "dialogRepairation": "การซ่อมแซม",
    "dialogInProcess": "อยู่ในกระบวนการ",
    "dialogCompleted": "เสร็จสมบูรณ์",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "การแก้ไขล้มเหลว!",
    "problemRequired": "กรุณาเลือกประเภทของปัญหา",
    "detailRequired": "กรุณาอธิบายปัญหาโดยละเอียด",
    "statusRequired": "กรุณาเลือกสถานะของบันทึก",
    "btnCancel": "ยกเลิก",
    "DeliveredTime": "เวลาจัดส่ง",
    "UpdatingTime": "เวลาปรับปรุง",
    "ITAdmin": "IT-Admin",
    "AdminReply": "การตอบกลับจากผู้ดูแล",
    "Note": "หมายเหตุ",
    "Detail": "รายละเอียด",
    "controlPanel": "แผงควบคุม",
    "DeviceType": "ประเภท",
    "dialogDeliveredTime": "เวลาจัดส่ง",
    "Submitter": "ผู้ส่ง"
  },
  "remoteControl": {
    "QuickActionName": "ชื่อ",
    "DeviceType": "ประเภท",
    "Description": "คำอธิบาย",
    "tableDescription": "คำอธิบาย",
    "editRemoteControl": "แก้ไขรหัสรีโมท",
    "QuickActionNameInput": "ชื่อ",
    "DescriptionInput": "คำอธิบาย",
    "save": "บันทึก",
    "Brand": "แบรนด์",
    "Model": "รุ่น",
    "EditACControlCode": "แก้ไขรหัสควบคุมเครื่องปรับอากาศ",
    "acBrand": "แบรนด์เครื่องปรับอากาศ",
    "acModel": "รุ่นเครื่องปรับอากาศ"
  },
  "card": {
    "btnAddCard": "เพิ่มการ์ด",
    "btnBatchAddCard": "เพิ่มการ์ดเป็นกลุ่ม",
    "tableCard": "หมายเลขการ์ด",
    "tableState": "สถานะ",
    "tableUser": "ผูกผู้ใช้",
    "tableID": "ชื่อเข้าสู่ระบบ",
    "tableType": "ประเภทการ์ด",
    "tableFfective": "วันที่หมดอายุ",
    "dialogCard": "หมายเลขการ์ด :",
    "dialogState": "สถานะ :",
    "dialogUser": "ผูกผู้ใช้ :",
    "dialogID": "ชื่อเข้าสู่ระบบ :",
    "dialogType": "ประเภทการ์ด :",
    "dialogFfective": "วันที่หมดอายุ :",
    "dialogRemarks": "หมายเหตุ :",
    "dialogAddTitle": "เพิ่มการ์ด",
    "dialogEidtTitle": "แก้ไขการ์ด",
    "code2201": "รูปแบบของระยะเวลาหมดอายุการ์ดไม่ถูกต้อง",
    "code2202": "การ์ดนี้ถูกผูกแล้ว",
    "code2203": "ผู้ใช้นี้ถูกผูกแล้ว",
    "code2204": "การ์ดนี้ยังไม่ได้ผูก",
    "mastCard": "การ์ดหลัก",
    "regularCard": "การ์ดทั่วไป",
    "permanent": "ถาวร",
    "coxPermanent": "ถาวร",
    "coxTime": "ระยะเวลาที่กำหนด",
    "tableDeviceName": "ชื่ออุปกรณ์",
    "tableDeviceID": "รหัสอุปกรณ์",
    "tableOperating": "การดำเนินการ",
    "tableOperatingTime": "เวลาการใช้งาน",
    "tableCardID": "หมายเลขการ์ด",
    "tableCardType": "ประเภทการ์ด",
    "tabluserName": "ชื่อผู้ใช้",
    "tabluserId": "รหัสผู้ใช้",
    "unlockPanel": "ปลดล็อคแผง",
    "unlock": "ปลดล็อกประตู",
    "conAll": "ทั้งหมด",
    "btnEnable": "เปิดใช้งาน",
    "btnDisable": "ปิดการใช้งาน",
    "enableSuccess": "เปิดใช้งานสำเร็จ",
    "stopSuccess": "ปิดการใช้งานสำเร็จ",
    "enableError": "ไม่สามารถเปิดใช้งาน",
    "stopError": "ไม่สามารถปิดการใช้งาน",
    "batchCard": "หมายเลขการ์ดเป็นกลุ่ม :",
    "titlCardField": "หมายเลขการ์ดห้ามเว้นว่าง",
    "titlCardFieldFormat": "ตัวอักษรและตัวเลขเท่านั้น",
    "dialogBachAddTitle": "เพิ่มการ์ดเป็นกลุ่ม",
    "pleaseTryAgain1": "หมายเลขการ์ดผิด (NO. :",
    "pleaseTryAgain2": ")，กรุณาลองใหม่"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/th.js